const messages = {
    en: {
        home: "Home",
        register: "Register",
        logout: "Logout",
        dashboard: "Dashboard",
        profile: "Profile",
        policies: "Policies",
        privacy_policy: "Privacy Policy",
        contact: "Contact",
        contacts: "Contacts",
        contact_us: "Contact Us",
        about: "About",
        search: "Search",
        users: "Users",
        roles: "Roles",
        role: "Role",
        roles_management: "Roles Management",
        role_management_of: "Role Management Of",
        permissions: "Permissions",
        permission: "Permission",
        permissions_management: "Permissions Management",
        users_management: "Users Management",
        developers: "Developers",
        developer: "Developer",
        developers_management: "Developers Management",
        clients: "Clients",
        client: "Client",
        clients_management: "Clients Management",
        projects: "Projects",
        project: "Project",
        projects_management: "Projects Management",
        communications_and_deals: "Communications and Deals",
        deal: "Deal",
        communications: "Communications",
        next: "Next",
        previous: "Previous",
        there_is_no_available_data: "There Is No Available Data",
        name: "Name",
        add: "Add",
        edit: "Edit",
        delete: "Delete",
        activate: "Activate",
        deactivate: "Deactivate",
        refresh: "Refresh",
        per_page: "Per Page",
        ex: "Ex.",
        display_name: "Display Name",
        save: "Save",
        cancel: "Cancel",
        description: "Description",
        procedures: "Procedures",
        the_name_field_is_required: "The Name Field Is Required.",
        the_display_name_field_is_required:
            "The Display Name Field Is Required.",
        select_permission: "Select Permission",
        search_permission: "Search Permission",
        sync_permissions: "Sync Permissions",
        sync_roles: "Sync Roles",
        administrator: "Administrator",
        leave_blank_to_keep_current: "Leave Blank To Keep Current",
        confirm_password: "Confirm Password",
        new_password_optional: "New Password (Optional)",
        user: "User",
        full_name: "Full Name",
        enter_full_name: "Enter Full Name",
        are_you_sure_you_want_to_deactivate_the_user:
            "Are You Sure You Want To Deactivate The User?",
        he_will_not_be_able_to_log_in: "He Will Not Be Able To Log In.",
        are_you_sure_you_want_to_activate_the_user:
            "Are You Sure You Want To Activate The User?",
        he_will_be_able_to_log_in: "He Will Be Able To Log In.",
        confirm_user_activation: "Confirm User Activation",
        confirm_user_deactivation: "Confirm User Deactivation",
        activation: "Activation",
        active: "Active",
        inactive: "Inactive",
        all: "All",
        sync: "Sync",
        created_by: "Created By",
        updated_by: "Updated By",
        created_at: "Created At",
        updated_at: "Updated At",
        address: "Address",
        mobile: "Mobile",
        project_no: "Project No.",
        project_name: "Project Name",
        district: "District",
        city: "City",
        project_type: "Project Type",
        source_other: "Other Source",
        area: "Area",
        price: "Price",
        rooms: "Rooms",
        bathrooms: "Bathrooms",
        discount_type: "Discount Type",
        discount: "Discount",
        ad_license: "Ad License",
        location_side: "Location Side",
        contract_type: "Listing Type",
        front: "Front",
        back: "Back",
        exclusive: "Exclusive",
        mediation: "Mediation",
        marketing: "Marketing",
        development: "Development",
        percentage: "Percentage",
        fixed: "Fixed",
        advertisement: "Advertisement",
        website: "Website",
        marketing_office: "Marketing Office",
        other: "Other",
        offers_and_listing: "Offers and Listings",
        discount_value: "Discount Value",
        listing_info: "Listing Information",
        links_and_media: "Links and Media",
        watch_video: "Watch Video",
        google_maps: "Google Maps",
        draft: "Draft",
        published: "Published",
        project_details_view: "Project Details View",
        system_logs: "System Logs",
        project_status: "Project Status",
        sale_status: "Sale Status",
        available: "Available",
        sold: "Sold",
        reserved: "Reserved",
        ready: "Ready",
        under_construction: "Under Construction",
        contract_start: "Contract Start",
        contract_end: "Contract End",
        add_new_unit: "Add New Unit",
        edit_unit: "Edit Unit",
        project_ref: "Project Reference",
        unit_name: "Unit Name",
        unit_index: "Unit Index",
        source_details: "Source Details",
        contract_period: "Contract Period",
        period: "Period",
        from: "From",
        to: "To",
        details: "Details",
        apartment: "Apartment",
        villa: "Villa",
        twin_house: "Twin House",
        roof: "Roof",
        floor: "Floor",
        side: "Side",
        map: "Map",
        video: "Video",
        update: "Update",
        youtube_link: "YouTube Link",
        current_location: "Current Location",
        Longitude: "Longitude",
        Latitude: "Latitude",
        copy_link: "Copy Link",
        open_in_google_maps: "Open In Google Maps",
        floor_number: "Floor Number",
        main_image: "Main Image",
        other_images: "Other Images",
        primary: "Primary",
        gallery: "Gallery",
        upload_main_image: "Upload Main Image",
        you_can_select_multiple_images_at_once:
            "You Can Select Multiple Images At Once",
        data_is_being_uploaded: "Data Is Being Uploaded",
        please_wait_the_images_are_currently_being_processed:
            "Please Wait, Images Are Currently Being Processed",
        view_gallery: "View Gallery",
        wait_few_seconds_for_result: "Wait A Few Seconds For The Result",
        none: "None",
        block: "Blocked",
        blacklist: "Blacklist",
        disqualified: "Disqualified",
        dnc: "Do Not Contact",
        new: "New",
        block_reasons: "Block Reasons",
        status: "Status",
        official_site: "Official Site",
        snapchat: "Snapchat",
        tiktok: "TikTok",
        instagram: "Instagram",
        facebook: "Facebook",
        google_ads: "Google Ads",
        whatsapp_business: "WhatsApp Business",
        email_ads: "Email Marketing",
        billboard: "Billboard",
        sms: "SMS",
        office_visit: "Office Visit",
        referral_from_client: "Client Referral",
        aqar: "Aqar",
        bayut: "Bayut",
        property_finder: "Property Finder",
        haraj: "Haraj",
        field_employee: "Field Employee",
        marketer: "Marketer",
        price_hunter: "Price Hunter",
        unserious: "Not Serious",
        invalid_information: "Invalid Information",
        identity_misrepresentation: "Identity Misrepresentation",
        ghosting: "Ghosting",
        abusive_behavior: "Abusive Behavior",
        no_show_expert: "No-Show",
        do_not_call: "Do Not Call",
        spamming: "Spamming",
        deal_management: "Deal Management",
        deals_management: "Deals Management",
        total_deals: "Total Deals",
        current_user: "Current User",
        unknown_client: "Unknown Client",
        transaction_log: "Transaction Log",
        no_transaction_log_yet: "No Transaction Log Yet",
        no_deals_recorded: "No Deals Recorded",
        users_chat: "Users Chat",
        stage: "Stage",
        from_stage: "From Stage",
        to_stage: "To Stage",
        call: "Call",
        visit: "Visit",
        send: "Send",
        last_activities: "Last Activities",
        contract: "Contract",
        not_distributed_yet: "Not Distributed Yet",
        loading: "Loading",
        search_options: "Search Options",
        select_user: "Select User",
        select_stage: "Select Stage",
        select_bank_sub_stage: "Select Bank Stage",
        client_notes: "Client Notes",
        transitioning_options: "Transition Options",
        transitioning_details: "Transition Details",
        log_new_transitioning: "Log New Transition",
        write_transitioning_note_here: "Write Transition Note Here",
        note_will_be_visible_in_the_transaction_log:
            "This Note Will Be Visible In The Transaction Log",

        facade_direction: "Building Direction",

        west: "West",
        east: "East",
        north: "North",
        south: "South",

        rejected_at: "Rejected At",
        receipt: "Receipt",
        request_new: "Request New",
        total_approved_amount: "Total Approved Amount",
        requested_at: "Requested At",

        request_receipt_for_deal: "Request Receipt For Deal",

        submit_receipt_request: "Submit Receipt Request",

        amount: "Amount",

        this_request_will_be_sent_for_review_Once_approved_an_official_document_number_and_approval_date_will_be_issued:
            "This request will be sent for review. Once approved, an official document number and approval date will be issued.",

        approved_by: "Approved By",

        rejection_reason_if_any: "If rejected, enter the rejection reason",

        write_reason_here: "Write Reason Here",

        approve_and_issue_number: "Approve and Issue Number",

        reject: "Reject",
        approve: "Approve",

        review_receipt_request: "Review Receipt Request",

        rejection_reason: "Rejection Reason",

        approved_at: "Approved At",

        submit_request: "Submit Request",

        confirm_approve_receipt: "Confirm Receipt Approval",

        no_receipts_found: "No Receipts Found",

        parties: "Parties",

        contract_total_commission: "Contract Total Commission",

        info: "Info",

        process_log: "Process Log",

        edit_commission: "Edit Commission",

        add_commission: "Add Commission",

        beneficiary: "Beneficiary",

        entity: "Entity",

        choose_beneficiary: "Choose Beneficiary",

        commission_type: "Commission Type",

        sales_commission: "Sales Commission",

        solutions_commission: "Solutions Commission",

        project_commission: "Project Commission",

        amount_due: "Amount Due",

        additional_details: "Additional Details",

        example_external_brokers_share: "Example: External Broker's Share",

        update_data: "Update Data",

        distribution_adoption: "Distribution Approval",

        date_awarded: "Date Awarded",

        commissions_distribution: "Commissions Distribution",

        review_and_approval: "Review and Approval",

        print_receipt: "Print Receipt",

        add_role: "Add Role",

        add_permission: "Add Permission",

        no_permissions_have_been_selected_yet:
            "No Permissions Have Been Selected Yet",

        saving: "Saving",

        successfully: "Successfully",

        no_permissions_selected_yet: "No Permissions Selected Yet",

        search_and_add_permission: "Search and Add Permission",

        action: "Action",

        select_reason: "Select Reason",

        optional: "Optional",

        add_new_deal: "Add New Deal",

        queries_and_deals: "Queries and Deals",

        queries: "Queries",

        reports: "Reports",

        report: "Report",

        payment_method: "Payment Method",

        select_payment_method: "Select Payment Method",

        cash: "Cash",

        bank: "Bank",

        leave_blank: "Leave Blank",

        Sorry_access_denied: "Sorry, Access Denied",

        you_do_not_have_sufficient_permissions_to_view_this_page_If_you_believe_this_is_an_error_please_contact_your_system_administrator:
            "You do not have sufficient permissions to view this page. If you believe this is an error, please contact your system administrator.",

        back_to_home: "Back To Home",

        return_to_the_previous_page: "Return To The Previous Page",

        contract_number: "Contract Number",

        client_number: "Client Number",

        all_stages: "All Stages",

        close_sub_stage: "Close Stage",

        bank_sub_stage: "Bank Stage",

        all_sources: "All Sources",

        contract_date_from: "Contract Date From",

        contract_date_to: "Contract Date To",

        created_at_from: "Created At From",

        created_at_to: "Created At To",

        at: "At",

        filter: "Filter",

        active_status_now: "Active Status Now",

        inactive_status_now: "Inactive Status Now",

        complete_documentation: "Complete Documentation",

        completed: "Completed",

        incomplete: "Incomplete",

        documents: "Documents",

        reset: "Reset",

        delay_days: "Delay Days",

        phone: "Phone",

        since_last_activity: "Since Last Activity",

        daily: "Daily",

        weekly: "Weekly",

        monthly: "Monthly",

        quarterly: "Quarterly",

        semi_annual: "Semi-Annual",

        annual: "Annual",

        custom_period: "Custom Period",

        all_roles: "All Roles",

        all_users: "All Users",

        overview: "Overview",

        sales_reports: "Sales Reports",

        finance_reports: "Finance Reports",

        real_estate_inventory: "Real Estate Inventory",

        performance: "Performance",

        account_settings: "Account Settings",

        profile_settings: "Profile Settings",

        profile_settings_description:
            "Manage your personal account settings and preferences.",

        danger_zone: "Danger Zone",

        two_factor_authentication: "Two-Factor Authentication",

        two_factor_description:
            "Two-factor authentication adds an extra layer of security to your account.",

        two_factor_enabled_title: "Two-Factor Authentication Is Enabled",

        finish_enabling_two_factor: "Finish Enabling Two-Factor Authentication",

        two_factor_not_enabled_title:
            "Two-Factor Authentication Is Not Enabled",

        two_factor_info_text:
            "Two-factor authentication adds an extra layer of security to your account by requiring an additional verification step.",

        qr_code_confirm_instruction:
            "Scan the QR code using your authenticator app to enable two-factor authentication.",

        qr_code_enabled_instruction: "Your QR code is ready.",

        setup_key: "Setup Key",

        code: "Code",

        recovery_codes_instruction:
            "Store these recovery codes in a secure place. They can be used if you lose access to your authenticator device.",

        enable: "Enable",

        confirm: "Confirm",

        regenerate_recovery_codes: "Regenerate Recovery Codes",

        show_recovery_codes: "Show Recovery Codes",

        disable: "Disable",
        update_password: "Update Password",

        update_password_description:
            "Ensure your account uses a strong password for security.",

        current_password: "Current Password",

        new_password: "New Password",

        saved: "Saved",

        browser_sessions: "Browser Sessions",

        browser_sessions_description:
            "Manage and log out your active sessions on other browsers and devices.",

        browser_sessions_content:
            "If necessary, you may log out of all other browser sessions across your devices.",

        unknown: "Unknown",

        this_device: "This Device",

        last_active: "Last Active",

        log_out_other_browser_sessions: "Log Out Other Browser Sessions",

        done: "Done",

        log_out_confirm_message:
            "Are you sure you want to log out of your other browser sessions?",

        delete_account: "Delete Account",

        permanently_delete_your_account: "Permanently Delete Your Account",

        delete_account_confirmation_message:
            "Are you sure you want to permanently delete your account?",

        delete_account_warning_text:
            "Once your account is deleted, all of its resources and data will be permanently deleted.",

        profile_information: "Profile Information",

        update_profile_description:
            "Update your account's profile information and email address.",

        photo: "Photo",

        select_a_new_photo: "Select A New Photo",

        remove_photo: "Remove Photo",

        email_unverified: "Email Unverified",

        resend_verification_email: "Resend Verification Email",

        verification_link_sent: "Verification Link Sent",

        client_evaluation: "Client Evaluation",

        blocked_clients_analysis: "Blocked Clients Analysis",

        quality_alert: "Quality Alert",

        price_hunters_description:
            "Price hunters are clients mainly focused on finding the lowest price or the best deal.",

        missed_opportunities: "Missed Opportunities",

        ghosting_or_invalid_info: "Ghosting or Invalid Information",

        top_block_reason_this_week: "Top Block Reason This Week",

        clients_count: "Clients Count",

        channel_efficiency: "Channel Efficiency",

        top_conversion: "Top Conversion",

        lead_source_analysis: "Lead Source Analysis",

        track_marketing_performance: "Track Marketing Performance",

        import_excel: "Import Excel",

        follow_up: "Follow-Up",

        interested: "Interested",

        field_visit: "Field Visit",

        reservation: "Reservation",

        waiting_for_transfer: "Waiting For Transfer",

        no_data_found: "No Data Found",

        north_east: "North East",

        north_west: "North West",

        south_east: "South East",

        south_west: "South West",

        north_south: "North / South",

        east_west: "East / West",

        location_link: "Location Link",

        new_to_sold: "New To Sold",

        visit_to_sold: "Visit To Sold",

        bank_to_closed: "Bank To Closed",

        adsplatforms: "Ads Platforms",

        access_token: "Access Token",

        enter_access_token: "Enter Access Token",

        update_platform: "Update Platform",

        add_new_platform: "Add New Platform",

        token: "Token",

        actions: "Actions",

        platform: "Platform",

        select_platform: "Select Platform",

        confirm_delete_text:
            "Are you sure you want to delete this platform? This action cannot be undone.",

        yes_delete: "Yes, Delete",

        deleted_successfully: "Deleted Successfully",

        contract_description: "Contract Description",

        deal_details: "Deal Details",

        please_enter_rejection_reason: "Please Enter Rejection Reason",

        finance_calculator: "Finance Calculator",

        choose_client: "Choose Client",

        management_and_queries: "Management and Queries",

        crm: "CRM",

        example: "Example",

        bathrooms_count: "Bathrooms Count",

        max_price: "Max Price",

        area_m2: "Area (m²)",

        rooms_count: "Rooms Count",

        smart_advanced_query_engine: "Smart Advanced Query Engine",

        natural_language_search_placeholder:
            "Write your search query in natural language...",

        example_yasmin_villa: "Example: Yasmin Villa",

        street_or_district_name: "Street or District Name",

        apply_search: "Apply Search",

        not_available: "Not Available",

        download_pdf: "Download PDF",

        querying: "Querying",

        location: "Location",

        hide_filters: "Hide Filters",

        filter_and_search: "Filter and Search",

        refresh_board: "Refresh Board",

        advanced_search: "Advanced Search",

        task_scheduling: "Task Scheduling",

        today_tasks: "Today's Tasks",

        tomorrow_tasks: "Tomorrow's Tasks",

        week_tasks: "This Week's Tasks",

        past_tasks: "Past Tasks",

        last_activity: "Last Activity",

        schedule_date: "Schedule Date",

        creation_date: "Creation Date",

        delayed: "Delayed",

        days: "Days",

        no_project: "No Project",

        sort_by: "Sort By",

        loading_data: "Loading Data",

        bank_stage: "Bank Stage",

        close_stage: "Close Stage",

        property_details: "Property Details",

        edit_property: "Edit Property",

        change: "Change",

        smart_client_evaluation_system: "Smart Client Evaluation System",

        update_seriousness_criteria_hint: "Update Seriousness Criteria",

        perform_new_evaluation: "Perform New Evaluation",

        unresponsive_client: "Unresponsive Client",

        contracted: "Contracted",

        initial_approval: "Initial Approval",

        appraisal: "Appraisal",

        issuing_contracts: "Issuing Contracts",

        signing_contracts: "Signing Contracts",

        issuing_check: "Issuing Check",

        waiting_transfer: "Waiting For Transfer",

        closed: "Closed",

        no_reason_provided: "No Reason Provided",

        automated_system: "Automated System",

        last_update: "Last Update",

        no_attachments_found: "No Files Attached",

        no_commission_data_found: "No Commission Data Found",

        points: "Points",

        client_seriousness_analysis:
            "Client Seriousness Analysis (Smart Point System)",

        requirements_clarity: "Requirements Clarity",

        precisely_defined: "Precisely Defined",

        vague: "Vague",

        inspection_questions_quality: "Inspection Questions Quality",

        technical_legal_questions: "Technical / Legal Questions",

        general_superficial_questions: "General / Superficial Questions",

        purchase_timeline: "Purchase Timeline",

        within_month: "Within A Month",

        three_to_six_months: "3–6 Months",

        exploration: "Exploration",

        payment_method_readiness: "Payment Method Readiness",

        cash_bank_approval: "Cash / Bank Approval",

        financing_not_started: "Financing Not Started",

        housing_support: "Housing Support (150K)",

        supported_eligible: "Supported & Eligible",

        price_offer_logic: "Price Offer Logic",

        logical_flexible: "Logical & Flexible",

        unrealistic_not_serious: "Unrealistic / Not Serious",

        response_commitment: "Response Commitment",

        committed_fast_response: "Committed & Fast Response",

        procrastination_disappearance: "Procrastination & Disappearance",

        decision_maker_presence: "Decision Maker Presence",

        brought_partner: "Brought Partner",

        always_alone: "Always Alone",

        golden_client_ready: "Golden Client - Ready To Close",

        serious_client_followup: "Serious Client - Needs Follow-Up",

        cold_client_exploring: "Cold Client - Exploring",

        advanced_unit_query: "Advanced Unit Query",

        real_estate_summary: "Real Estate Activity & Sales Summary",

        total_yesterday_work: "Total Work Yesterday:",

        yesterday_activities: "Yesterday's Activities",

        from_activities_table: "From Activities Table",

        yesterday_transitions: "Yesterday's Transitions",

        from_transitions_log: "From Transition Logs",

        today_scheduled: "Today's Scheduled Tasks",

        based_on_schedule: "Based On Schedule",

        total_funnel: "Total Funnel",

        latest_deals_week: "Latest Deals Of The Week",

        last_7_days: "Last 7 Days",

        date_added: "Date Added",

        no_deals_week: "No Deals Added This Week",

        pipeline_analysis: "Pipeline Analysis",

        save_activity_and_schedule: "Save Activity And Schedule",

        activities_and: "Activities And",

        transitions: "Transitions",

        market_stats_summary: "Market Statistics Summary",

        based_on_current_results: "Based On Current Search Results",

        price_range: "Price Range",

        currency_sar: "Currency: SAR",

        sar_unit: "SAR",

        area_distribution: "Area Distribution",

        unit_sqm: "Unit: Square Meter",

        sqm_unit: "m²",

        no_results_found: "No Results Found",

        median: "Median",

        minimum: "Minimum",

        maximum: "Maximum",

        choose_city: "Choose City",

        choose_district: "Choose District",

        choose_property_type: "Choose Property Type",

        results: "Results",

        choose_price_range: "Choose Price Range",

        my_clients: "My Clients",
        today: "Today",
        tomorrow: "Tomorrow",
        yesterday: "Yesterday",
        next_week: "Next Week",
        last_week: "Last Week",
        all_employees: "All Employees",

        this_account_is_inactive_please_check_with_the_system_administrator:
            "This account is inactive. Please check with the system administrator.",
        the_provided_credentials_are_incorrect:
            "The provided credentials are incorrect.",
        failed_to_log_in_Please_try_again_later:
            "Failed to log in. Please try again later.",
        email_address_field_required: "Email address field is required.",
        the_provided_email_address_is_not_valid:
            "The provided email address is not valid.",
        password_field_required: "Password field is required.",
        login_failed: "Login failed. Please try again.",

        welcome_back: "Welcome back!",
        login_subtitle: "Please enter your details to access the control panel",
        email: "Email Address",
        enter_email: "name{'@'}company.com",
        password: "Password",
        enter_password: "••••••••",
        forgot_password: "Forgot your password?",
        remember_me: "Remember me",
        login: "Sign In",
        logging_in: "Logging in...",
        success_login: "Login successful! Redirecting...",
        system_footer: "All rights reserved to the Cloud System.",

        write_developer_name: "Write Developer Name",
        write_city_name: "Write City Name",
        write_district_name: "Write District Name",
        write_client_name_or_phone: "Write Client Name or Phone",
        notes: "Notes",
        log_new_activity: "Log New Activity",
        activity_type: "Activity Type",
        activity_details: "Activity Details",
        add_activity: "Add Activity",
        what_happened_during_activity: "What Happened During the Activity",
        activity_status: "Activity Status",
        success: "Successful",
        unsuccess: "Unsuccessful",
        are_you_sure: "Are You Sure?",
        do_you_really_want_to_proceed_with_this_action_this_process_cannot_be_undone:
            "Do you really want to proceed with this action? This process cannot be undone.",
        yes_i_m_sure: "Yes, I'm Sure",
        no_cancel: "No, Cancel",
        documents_and_attachments_of_the_deal:
            "Documents and Attachments of the Deal",
        add_new_attachment: "Add New Attachment",
        edit_attachment: "Edit Attachment",
        choose_image_or_pdf_file: "Choose Image or PDF File",

        postponing_purchase: "Postponing Purchase",
        purchasing_from_another_company: "Purchasing from Another Company",
        property_unavailable: "Property Unavailable",
        area_unavailable: "Area Unavailable",
        not_eligible_for_financing: "Not Eligible for Financing",
        low_budget: "Low Budget",
        client_not_responding: "Client Not Responding",
        does_not_respond: "Does Not Respond",
        not_interested: "Not Interested",
        select_closed_sub_stage: "Select Close Reason",

        stage_transitions: "Stage Transitions",
        executed_activities: "Executed Activities",
        new_projects_added: "New Projects Added",
        new_clients: "New Clients",
        new_developers: "New Developers",
        activity_density_analysis: "Activity Density Analysis",
        by: "By",
        smart_time_comparison: "Smart Time Comparison",
        activities_count: "Activities Count",
        no_activities_recorded_period:
            "No Activities Recorded During This Period",

        final_closing_rate: "Final Closing Rate",
        updated_based_on_sold_deals: "Updated Based on Sold Deals",
        sold_deals_count: "Sold Deals Count",
        active_deals: "Active Deals",
        top_3_sales_sources: "Top 3 Sales Sources",
        sold_deal_unit: "Sold Deal Unit",
        no_sales_data_currently: "No Sales Data Currently",

        commissions_and_profits_analysis: "Commissions and Profits Analysis",
        total_commissions: "Total Commissions",
        highest_commission_recorded: "Highest Commission Recorded",
        lowest_commission_recorded: "Lowest Commission Recorded",
        average_commissions: "Average Commissions",

        collected_cash_flow_analysis: "Collected Cash Flow Analysis",
        total_actually_collected: "Total Actually Collected",
        highest_receipt: "Highest Receipt",
        lowest_receipt: "Lowest Receipt",
        average_receipts: "Average Receipts",

        commission_growth_performance: "Commission Growth Performance",
        commission_distribution: "Commission Distribution",
        from_developer: "From Developer",
        from_client: "From Client",

        employees_performance_commissions: "Employees Performance Commissions",
        top_collecting: "Top Collecting",
        latest_accepted_receipts: "Latest Accepted Receipts",
        receipt_no: "Receipt No.",

        top_selling_district: "Top Selling District",
        highest_average_price: "Highest Average Price",
        in: "In",
        units_available_for_sale_now: "Units Available for Sale Now",
        total_units_sold: "Total Units Sold",
        units_waiting_for_procedures: "Units Waiting for Procedures",
        sell_through_rate: "Sell-through Rate",

        distribution_of_added_units_by_selected_period:
            "Distribution of Added Units by Selected Period",

        total: "Total",
        unit: "Unit",
        developer_performance: "Developer Performance",
        sales: "Sales",

        district_details: "District Details",
        district_name: "District Name",
        average_area: "Average Area",
        average_price: "Average Price",
        m2: "m²",

        inventory_analysis_by_property_type:
            "Inventory Analysis by Property Type",

        property_type: "Property Type",
        contract_type_distribution: "Contract Type Distribution",

        sources: "Sources",
        inactive_units: "Inactive Units",
        archived_or_inactive_units: "Archived or Inactive Units",

        top_performer: "Top Performer",
        close_rate: "Close Rate",

        deals_transfer_report: "Deals Transfer Report",
        track_deals_movement_description: "Track Deals Movement",

        total_transfers: "Total Transfers",
        latest_transfer_notes: "Latest Transfer Notes",

        agents_ranking_by_sales: "Agents Ranking by Sales",
        live_update: "Live Update",
        agent: "Agent",
        successful_operations: "Successful Operations",
        conversion_rate: "Conversion Rate",
        commissions_earned: "Commissions Earned",

        daily_activity_indicators: "Daily Activity Indicators",
        attempts_per_sale: "Average of Attempts per Sale",
        smart_numbers_insight: "Smart Numbers Insight",

        active_agent: "Active Agent",
        active_agent_description: "Active Agent Description",

        followup_quality: "Follow-up Quality",
        followup_quality_description: "Follow-up Quality Description",

        reception: "Reception",
        reception_description: "Reception Description",

        pipeline_stages: "Sales Pipeline Stages",
        conversion_efficiency: "Conversion Efficiency",

        payment_methods: "Payment Methods",
        bank_finance: "Bank Finance",
        bank_stages_analysis: "Bank Stages Analysis",

        deal_loss_reasons: "Deal Loss Reasons",

        incorrect_information: "Incorrect Information",

        hero_title:
            "Manage real estate deals and clients with intelligence and speed.",
        hero_subtitle:
            "An integrated system specifically designed to monitor daily indicators and analyzes, and facilitate sales team tasks in a fast and organized work environment.",
        secure_badge:
            "Fully secured and encrypted according to international standards",
        system_badge: "Real Estate System",
        copy_to_clipboard: "Copy to clipboard",
        all_projects: "All Projects",
        has_location: "Has Location",
        description_keywords_search_placeholder:
            "Search by description keywords...",
        no_location: "No Location",
        assigned_projects: "Assigned Projects",
        choose_employee: "Choose Employee",
        assign_permission: "Assign Permission",
        cancel_assign: "Cancel Assignment",
        sold_deals: "Sold Deals",
        incoming_deal: "Incoming Deal",
        marketing_channel_analysis_description:
            "Marketing Channel Analysis Description",
        marketing_channel_analysis: "Marketing Channel Analysis",
        call_success_rate: "Call Success Rate",
        visit_success_rate: "Visit Success Rate",
        activity_efficiency: "Activity Efficiency",
        expected_commissions_pipeline: "Expected Commissions Pipeline",
        get_matching_projects: "Get Matching Projects",
        commissions_earned_completed_sales:
            "Commissions Earned - Completed Sales",
        delete_message: "Delete Message",
        current_deals: "Current Deals",
        sold_units: "Sold Units",
        my_pending_commissions: "My Pending Commissions",
        my_sales_funnel: "My Sales Funnel",
        no_recent_activities: "No Recent Activities",
        highest_density_stock: "Highest Density Stock",
        units_displayed: "Units Displayed",
        stagnant_inventory: "Stagnant Inventory",
        stagnant_inventory_description:
            "Units that have been on the market for an extended period without significant interest or activity.",
        complexes_and_project_buildings: "Complexes and Project Buildings",
        total_inventory: "Total Inventory",
        inventory_analysis_by_district: "Inventory Analysis by District",
        monitoring_available_inventory_density_against_past_sales:
            "Monitoring Available Inventory Density Against Past Sales",
        including_the_uncovered_neighborhoods_within_the_same_city:
            "Including the Uncovered Neighborhoods Within the Same City",
        no_projects_added: "No Projects Added",
        available_for_sale: "Available for Sale",
        opportunity_uncovered_investment: "Uncovered Investment Opportunity",
        average_price_and_area: "Average Price and Area",
        targeted_neighborhood: "Targeted Neighborhood",
        for_investment_expansion_and_to_attract_real_estate_offers:
            "For Investment Expansion and to Attract Real Estate Offers",
        displayed_density: "Displayed Density",
        m: "M",
        stock_density: "Stock Density",
        monthly_unit_flow_rate: "Monthly Unit Flow Rate",
        annual_unit_flow_rate: "Annual Unit Flow Rate",
        weekly_unit_flow_rate: "Weekly Unit Flow Rate",
        daily_available_units_flow_rate: "Daily Available Units Flow Rate",
        available_inventory_liquidity: "Available Inventory Liquidity",
        no_data_available: "No Data Available",
        all_types_of_construction: "All Types of Construction",
        from_the_clients_of_the_kinetic_system:
            "From the Clients of the Kinetic System",
        without: "Without",
        transfers: "Transfers",
        projects_added: "Projects Added",
        developers_added: "Developers Added",
        clients_added: "Clients Added",
        next_contact_date: "Next Contact Date",
        update_schedule: "Update Schedule",
        schedule_next_contact: "Schedule Next Contact",
        reservation_to_sold: "Reservation To Sold",
        seriousness_score: "Seriousness Score",
        transiting_all_deals: "Transiting All Deals",
        selected_deals: "Selected Deals",
        select_all_projects: "Select All Projects",
        selected_projects: "Selected Projects",
        select_targeted_employee: "Select Targeted Employee",
        system_configuration: "System Configuration",
        manage_company_identity_and_settings:
            "Manage Company Identity and Settings",
        loading_settings: "Loading Settings",
        company_name: "Company Name",
        enter_company_name: "Enter Company Name",
        company_logo: "Company Logo",
        drag_or_click_to_upload_logo: "Drag or Click to Upload Logo",
        company_stamp: "Company Stamp",
        drag_or_click_to_upload_stamp: "Drag or Click to Upload Stamp",
        save_settings: "Save Settings",
        settings_saved_successfully: "Settings Saved Successfully",
        validation_error_please_check_fields:
            "Validation Error: Please Check Fields",
        something_went_wrong: "Something Went Wrong",
        commercial_register: "Commercial Register",
        enter_commercial_register: "Enter Commercial Register",
        tax_number: "Tax Number",
        enter_tax_number: "Enter Tax Number",
        enter_phone_number: "Enter Phone Number",
        unit_link: "Unit Link",
        discover_more: "Discover More",
        banks: "Bank",
        activities: "Activities",
        edit_activity: "Edit Activity",
        commission: "Commission",
        sort_latest: "Sort Latest",
        sort_oldest: "Sort Oldest",
        sort_highest_commission: "Sort Highest Commission",
        sort_lowest_commission: "Sort Lowest Commission",
        sort_highest_price: "Sort Highest Price",
        sort_lowest_price: "Sort Lowest Price",
        sort_largest_area: "Sort Largest Area",
        select_bank_name: "Select Bank Name",
        banks_management: "Banks Management",
        add_bank: "Add Bank",
        bank_name: "Bank Name",
        bank_code: "Bank Code",
        add_employee: "Add Employee",
        rating: "Rating",
        employees_of: "Employees of",
        edit_bank: "Edit Bank",
        add_new_employee: "Add New Employee",
        enter_employee_name: "Enter Employee Name",
        rating_out_of_10: "Rating (Out of 10)",
        profit_rate: "Profit Rate",
        search_banks: "Search Banks",
        bank_employee: "Bank Employee",
        edit_deal: "Edit Deal",
        no_data: "No Data",
        whatsapp_welcome_message: "Whatsapp Welcome Message",
        enter_whatsapp_welcome_message: "Enter Whatsapp Welcome Message",
        closed_or_no_signal: "Switched Off / No Coverage",
        bad_timing: "Inappropriate Timing",
        callback_no_reply: "Requested Callback - No Answer",
        line_busy: "Line Busy (Another Call)",
        call_cancelled: "Call Cancelled / Hung Up",
        no_answer: "No Answer / Ringing",
        requested_callback_later: "Requested Callback Later (No Reply)",
        whatsapp_only: "Requested WhatsApp Contact Only",
        wrong_number: "Wrong Number / No WhatsApp",
        wrong_person: "Number Belongs to Someone Else",
        sequential_conversion: "Sequential Stage Conversion Rates",
        direct_target_conversion: "Direct Target Conversion Rates",
        new_to_followup: "New to Follow-up",
        followup_to_interested: "Follow-up to Interested",
        interested_to_visit: "Interested to Field Visit",
        visit_to_reservation: "Field Visit to Reservation",
        reservation_to_bank: "Reservation to Bank",
        bank_to_sold: "Bank to Sold",
        any_to_visit: "Conversion rate from any stage to Visit",
        any_to_reservation: "Conversion rate from any stage to Reservation",
        any_to_bank: "Conversion rate from any stage to Bank",
        any_to_sold: "Conversion rate from any stage to Sold",
        any_to_closed: "Conversion rate from any stage to Closed",
        lead_quality_and_demographics: "Lead Quality & Demographics",
        avg_seriousness_score: "Avg. Seriousness Score",
        sakani_supported: "Sakani Supported",
        residential_vs_investment: "Purchase Purpose",
        nationality_ratio: "Nationality Ratio",
        purpose_ratio_format:
            "{residential} Residential / {investment} Investment",
        nationality_ratio_format: "{citizen} Citizen / {resident} Resident",
        deals_by_city: "Customer Distribution by City",
        client_count_unit: "Clients",
        active_banks_analysis: "Active Banks Analysis",
        deals: "Deals",
        top_bank_employees: "Most Active Bank Employees",
        all_sub_stage: "All Sub-Stages",
        all_banks: "All Banks",
        current_live_snapshot: "Current Live Snapshot",
        live_snapshot_desc:
            "This snapshot provides a real-time overview of the current status of all deals, clients, and banks in the system. It allows you to quickly assess the overall performance and identify areas that may require attention or improvement.",
        main_stages_now: "Main Stages Now",
        bank_sub_stages_now: "Bank Sub-Stages Now",
        total_clients_now: "Total Clients Now",
        external_marketer: "External Marketer",
        duplicated_clients: "Duplicated Clients",
        undefined: "Undefined",
        unit_number: "Unit Number",
        register_new_field_visit: "Register New Field Visit",
        comprehensive_failure_reasons_analysis:
            "Comprehensive Failure Reasons Analysis",
        view_stats_and_table: "View Stats and Table",
        add_new_visit: "Add New Visit +",
        loading_stats: "Loading statistics...",
        visit_result: "Visit Result",
        successful_visit: "Successful",
        failed_visit: "Failed",
        failure_reason_label: "Failure Reason",
        select_specific_reason: "Select specific reason",
        additional_notes: "Additional Notes",
        write_notes_here: "Write notes here...",
        save_visit_data: "Save Visit Data",
        total_visits: "Total Visits",
        successful_visits: "Successful Visits",
        failed_visits: "Failed Visits",
        failure_reasons_and_total_counts:
            "Failure reasons list and total counts:",
        loading_and_preparing_reasons_table:
            "Loading and preparing reasons table...",
        close: "Close",
        warning: "Warning",
        please_select_failure_reason:
            "Please select the specific failure reason",
        added_successfully: "Added Successfully",
        visit_registered_successfully: "Visit has been registered successfully",
        error: "Error",
        error_saving_visit: "An error occurred while saving visit data",

        price_too_high: "Price Too High",
        area_too_small: "Area Too Small",
        poor_finishing: "Poor Finishing",
        unsuitable_location: "Unsuitable Location",
        no_bank_surplus: "No Bank Surplus",
        narrow_street: "Narrow Street",
        no_maid_room: "No Maid Room",
        no_driver_room: "No Driver Room",
        single_entrance: "Single Entrance",
        no_majlis_partition: "No Majlis Partition",
        open_kitchen: "Open Kitchen",
        closed_kitchen: "Closed Kitchen",
        only_one_elevator: "Only One Elevator",
        reset_filters: "Reset Filters",
        advanced_filters: "Advanced Filters",
        all_contracts: "All Contracts",
        filtered_live_snapshot: "Filtered Live Snapshot",
        filtered_snapshot_desc: "Filtered Snapshot Desc",
        filtered_clients_now: "Filtered Clients Now",
        users_performance_summary: "Users Performance Summary",
        users_performance_desc: "Users Performance Desc",
        employee_role: "Employee Role",
        total_assigned_clients: "Total Assigned Clients",
        new_clients_count: "New Clients Count",
        admin: "Admin",
        ceo: "CEO",
        sales_manager: "Sales Manager",
        sales_employee: "Sales Employee",
        sales_field: "Sales Field",
        need_calculation: "Need Calculation",
        notifications: "Notifications",
        no_new_notifications: "No New Notifications",
        mark_as_read: "Mark as Read",
        open: "Open",
        mark_all_read: "Mark All Read",
        selling_stage: "Selling Stage",
        call_status: "Call Status",
        next_call: "Next Call",
        chat_title: "Digital Chats",
        broadcast_title: "Public Team Chat",
        online_count: "Online on the platform",
        online_now: "Online Now",
        click_to_chat: "Click to start a fun chat",
        change_theme: "Change Creative Theme",
        new_chat: "New Chat",
        general_chat: "General Chat",
        pinned: "Pinned",
        broadcast_subtitle: "A group message to all our creative team members",
        no_chats: "No active chats yet",
        no_chats_hint:
            "Click the (+) button above to start a beautiful conversation",
        active_now: "Active now",
        click_to_talk: "Click to chat",
        write_message: "Write a wonderful message...",
        search_placeholder: "Search for an amazing teammate...",
        no_users_found: "No teammates match your search",
        send_message: "Send",
        chat_with: "Chat",
        delete_confirm: "Do you want to delete this message for everyone?",
        delete_failed: "Failed to delete message",
        employee: "Star Employee",
        not_connected: "Offline for now",
        apartment_under_construction: "Apartment Under Construction",
        apartment_ready: "Apartment Ready",
        roof_under_construction: "Roof Under Construction",
        roof_ready: "Roof Ready",
        villa_under_construction: "Villa Under Construction",
        villa_ready: "Villa Ready",
        building: "Building",
        land: "Land",
        rent: "Rent",
        client_details: "Client Details",
        client_details_summary:
            "Summary of client profile, target geographic scope, and financial targets.",
        edit_client: "Edit Client",
        basic_client_data: "Basic Client Data",
        client_name: "Client Name",
        other_deals: "Other Deals",
        mobile_number: "Mobile Number",
        client_nationality: "Client Nationality",
        citizen: "Citizen",
        resident: "Resident",
        current_client_city: "Current Client City",
        client_request_geographic: "Client Request & Target Geographic Scope",
        required_property_type: "Required Property Type",
        required_location: "Required Location",
        required_rooms_count: "Required Rooms Count",
        current_stage: "Current Stage",
        financial_funding_data: "Financial & Funding Data",
        client_budget: "Client Budget",
        sar: "SAR",
        client_salary: "Client Salary",
        purchase_purpose: "Purchase Purpose",
        residential: "Residential",
        investment: "Investment",
        is_sakani_supported: "Is Sakani Supported?",
        support_status: "Support Status",
        supported: "Supported",
        not_supported: "Not Supported",
        executive_stage_details: "Executive Stage Details",
        closing_reason: "Closing Reason",
        enter_statement: "Enter Statement",
        statement: "Statement",
        official_receipt_note: "Official Receipt Note",
        company: "Company (Internal)",
        receipt: {
            title: "Payment Receipt",
            date: "Date",
            number: "Receipt No.",
            commercial_register: "C.R.",
            tax_number: "Tax No.",
            company_logo: "Company Logo",
            client_name: "Client Name",
            unit_number: "Unit No.",
            district: "District",
            property_type: "Property Type",
            status: "Status",
            area: "Area",
            square_meter: "sqm",
            unit_details: "Unit Details",
            rooms: "Rooms",
            bathrooms: "Bathrooms",
            facade: "Facade",
            for_statement: "Being for",
            default_statement:
                "Against booking the above-mentioned real estate unit.",
            amount_received: "Amount Received",
            total_amount: "Total Amount",
            currency: "SAR",
            terms_line1:
                "An electronically approved financial receipt issued by the company's financial system with the details shown above.",
            terms_line2:
                "The property data and areas mentioned have been reviewed and matched with the official engineering deeds and local regulations.",
            authorized_signature: "Authorized Signature & Stamp",
            official_stamp: "Official Stamp",
        },
        no_kitchen_window: "No Kitchen Window",
        no_living_room_window: "No Living Room Window",
        laborers_in_area: "Laborers in the Area",
        export_image: "Export Image",
        download_image: "Download Image",
        exported_successfully: "Exported Successfully",
        project_visits_stats: "Project Visits Statistics",
        select_all_that_apply: "Select all that apply",
        analytical_report_title: "Analytical Report for Sales and Field Visits",
        chart_title:
            "📊 Graphical representation of rejection reasons and property unsuitability distribution:",
        visit_unit: "Visit",
        no_reasons_recorded:
            "There are currently no recorded failure reasons to display in the chart.",
        image_exported_successfully:
            "The analytical image has been downloaded successfully",
        error_exporting_image: "Failed to export the report as an image",

        comprehensive_global_snapshot: "Comprehensive Global Snapshot",
        fixed_accumulated_ledger_snapshot: "Fixed Accumulated Ledger Snapshot",
        global_net_profit: "Global Net Profit",
        global_credit: "Global Credit",
        global_debit: "Global Debit",
        global_receipts: "Global Receipts",
        highest_commission: "Highest Commission",
        lowest_commission: "Lowest Commission",
        avg_commissions: "Avg Commissions",
        dynamic_filtered_commissions_analysis:
            "Dynamic Filtered Commissions Analysis",
        filtered_credit: "Filtered Credit",
        filtered_debit: "Filtered Debit",
        filtered_net_profit: "Filtered Net Profit",
        filtered_max_comm: "Filtered Max Comm",
        filtered_min_comm: "Filtered Min Comm",
        filtered_avg_comm: "Filtered Avg Comm",
        filtered_approved_receipts_stream: "Filtered Approved Receipts Stream",
        total_filtered_receipts: "Total Filtered Receipts",
        max_receipt: "Max Receipt",
        min_receipt: "Min Receipt",
        avg_receipts_stream: "Avg Receipts Stream",
        receipt_inflow_vs_commission_outflow:
            "Receipt Inflow vs Commission Outflow",
        receipt_impact_desc:
            "Impact: Shows cash collection efficacy relative to payables.",
        receipts: "Receipts",
        credit: "Credit",
        commissions: "Commissions",
        net_profit_saturation_chart: "Net Profit Saturation Chart",
        saturation_impact_desc:
            "Impact: Gauges core business margins from total revenue generated.",
        efficiency: "Efficiency",
        efficiency_note: "Higher rates indicate excellent profit retention.",
        financial_risk_balancing_gap_analysis:
            "Financial Risk & Balancing Gap Analysis",
        gap_impact_desc:
            "Impact: Monitors leverage limits to prevent operational liquidity crunch.",
        commissions_distribution_by_classification_type:
            "Commissions Distribution By Classification Type",
        source: "Source",
        debit: "Debit",
        dynamic_employee_financial_performance:
            "Dynamic Employee Financial Performance",
        employee_performance_desc:
            "Displays commission generation matrix per employee.",
        employee_name: "Employee Name",
        total_credit: "Total Credit",
        total_debit: "Total Debit",
        commissions_by_financial_source: "Commissions By Financial Source",
        detailed_commissions_deal_by_deal_report:
            "Detailed Commissions Deal-by-Deal Report",
        deal_report_desc:
            "A global breakdown of every single transaction and its micro-beneficiaries.",
        deal_id: "Deal ID",
        primary_creditor: "Primary Creditor",
        micro_beneficiaries_shares: "Micro Beneficiaries & Shares",
        na: "N/A",
        no_beneficiaries_found: "No Beneficiaries found",
        recent_approved_receipt_requests: "Recent Approved Receipt Requests",
        sold_date: "Sold Date",
        net_profit: "Net Profit",
        client_request: "Client Request",
        no_additional_details: "No Additional Details",
        no_notes_available: "No Notes Available",
        regulations: "Regulations",
        total_assigned_deals: "Total Assigned Deals",
        new_deals_count: "New Deals Count",
        users_performance_desc_histories: "Users Performance Desc Histories",
        matching_projects: "Matching Projects",
        smart_matching: "Smart Matching",
        yes: "Yes",
        no: "No",
        closure_reasons: "Closure Reasons",
        request_description: "Request Description",
        under_review: "Under Review",
        pending_manager: "Pending Manager",
        pending_finance: "Pending Finance",
        approved: "Approved",
        rejected: "Rejected",
        rejection_reason: "Rejection Reason",
        commission_status_and_reviews_log: "Commission Status & Reviews Log",
        no_reason_provided: "No reason provided.",
        beneficiary: "Beneficiary",
        amount: "Amount",
        sar: "SAR",
        approval_stages_and_logs: "Approval Stages & Logs",
        by: "By",
        automated_system: "Automated System",
        additional_details: "Additional Details",
        close: "Close",
        commissions_distribution: "Commissions Distribution",
        financial_operations: "Financial Operations",
        request_new: "Request New",
        beneficiary: "Beneficiary",
        operation_type: "Operation Type",
        commission_type: "Commission Type",
        approval_level: "Approval Level",
        amount: "Amount",
        credit_plus: "Credit (+)",
        debit_minus: "Debit (-)",
        sales: "Sales",
        solutions: "Solutions",
        project: "Project",
        disbursement_settlement: "Disbursement / Settlement",
        sar: "SAR",
        total_commissions_revenue_credit: "Total Commissions Revenue (Credit):",
        total_distributions_and_expenses_debit:
            "Total Distributions and Expenses (Debit):",
        net_remaining_commissions_balance: "Net Remaining Commissions Balance:",
        no_commission_data_found: "No commission data found",
        edit_commission: "Edit Commission",
        add_commission: "Add Commission",
        transaction_type: "Transaction Type (Accounting Operation)",
        credit_incoming_revenue: "Credit (Company Earned Revenue)",
        debit_deducted_share: "Debit (Payout / Deducted Share)",
        beneficiary: "Beneficiary",
        choose_beneficiary: "Choose Beneficiary",
        approval_status_level: "Approval Status Level",
        commission_type: "Commission Type",
        project_commission: "Project Commission",
        sales_commission: "Sales Commission",
        solutions_commission: "Solutions Commission",
        payout_disbursement: "Payout / Financial Settlement",
        date_awarded: "Date Awarded",
        amount_due: "Amount Due",
        sar: "SAR",
        additional_details: "Additional Details",
        example_external_brokers_share: "Example: External broker's share",
        cancel: "Cancel",
        update_data: "Update Data",
        distribution_adoption: "Approve Distribution",
        error: "Error",
        ads_platforms: "Ads Platforms",
        manage_ads_platforms: "Manage Advertising Platforms",
        platforms_description:
            "Add, edit marketing publishing platforms, and follow up on their mandatory status.",
        add_new_platform: "Add New Ads Platform",
        edit_ads_platform: "Edit Advertising Platform",
        platform_name: "Platform Name",
        platform_placeholder: "e.g., Aqar, TikTok...",
        required_publishing_platform: "Mandatory Publishing Platform",
        required_platform_hint:
            "Forces the employee to upload the ad to it (e.g., Aqar, Bayut)",
        cancel: "Cancel",
        saving: "Saving...",
        update_data: "Update Data",
        save_platform: "Save Platform",
        registered_platforms_list: "Registered Platforms List",
        platform: "Platform",
        table_platform_name: "Platform Name",
        table_platform_type: "Platform Type",
        table_actions: "Actions",
        no_platforms_found: "No registered platforms found at the moment.",
        status_required: "Mandatory",
        status_optional: "Optional",
        edit: "Edit",
        delete: "Delete",
        brokerage_contracts_ads: "Brokerage Contracts Ads",
        brokerage_ads_title: "Brokerage Contracts & Marketing Tracking",
        brokerage_ads_subtitle:
            "Track advertising licenses and uploaded URLs on mandatory and optional platforms.",
        search_by_code: "Search by Unit Number",
        search_placeholder: "Type unit number here...",
        ad_platform_status: "Platform Publishing Status",
        all: "All",
        completed_required: "Completed Mandatory Platforms",
        never_published: "Never Published",
        missing_required_platforms: "Missing Mandatory Platforms",
        filter_ad_license: "Filter by Ad License",
        filter_ad_contract: "Filter by Ad Contract",
        has_license: "Has Ad License",
        has_contract: "Has Contract Number",
        no_license: "No Ad License",
        no_contract: "No Contract Number",
        filter_by_employee: "Filter by Employee",
        all_employees: "All Employees",
        project_unit: "Project / Unit",
        ad_license_column: "Ad License",
        ad_contract_column: "Ad Contract",
        required_badge: "Mandatory",
        optional_badge: "Optional",
        actions: "Actions",
        no_mediation_projects:
            "No mediation projects found matching the criteria.",
        unit_code: "Code",
        no_license_added: "No license added",
        no_contract_added: "No contract added",
        published: "Published",
        not_published: "Not Published",
        edit_license_btn: "Edit License",
        add_license_btn: "Add License",
        manage_links_btn: "Manage Links",
        manage_links_modal_title: "Manage Marketing Platform Links",
        cancel: "Cancel",
        saving: "Saving...",
        save_changes: "Save Changes",
        license_modal_title: "Project Ad License",
        license_input_label: "Enter Approved Ad License Number",
        license_placeholder: "e.g., 72000xxxx",
        save_license_btn: "Save License",
        brokerage_ads: "Brokerage Contracts",
        contract_description_label: "Enter the brokerage contract description",
        sub_contract_description_label: "Enter the sub-contract description",
        date_sold: "Date of Sale",
        beneficiary_totals: "Beneficiary Totals",
        sort_smallest_area: "Sort Smallest Area",
        fixed_accumulated_ledger_snapshot_tip:
            "A static cumulative summary reflecting all historical financial processes in the system since inception (unaffected by current date filters).",
        global_net_profit_tip:
            "The company's total net profit: gross credit amounts minus all historical deductions and debit amounts.",
        global_credit_tip:
            "The sum of all standard commissions and revenue amounts credited to the company since launch.",
        global_debit_tip:
            "The sum of all commissions distributed to employees or deductions imposed (debit) since launch.",
        global_receipts_tip:
            "The total of all cash funds actually received and approved in the treasury via receipt vouchers.",
        highest_commission_tip:
            "The highest single commission value recorded in the system's history.",
        lowest_commission_tip:
            "The lowest single commission value recorded in the system's history.",
        avg_commissions_tip:
            "The calculated average value of registered financial commission entries.",
        dynamic_filtered_commissions_analysis_tip:
            "A dynamic financial analysis that updates instantly based on the selected date range or employee filters at the top.",
        filtered_credit_tip:
            "Total credit amounts recorded for the company during the specified search period only.",
        filtered_debit_tip:
            "Total commissions and obligations allocated to employees during the specified search period only.",
        filtered_net_profit_tip:
            "The company's net profit (Credit minus Debit) recorded within the active filter range.",
        filtered_max_comm_tip:
            "The maximum commission achieved within the current filtered scope.",
        filtered_min_comm_tip:
            "The minimum commission achieved within the current filtered scope.",
        filtered_avg_comm_tip:
            "The average commission rate calculated for operations within the active filter scope.",
        filtered_approved_receipts_stream_tip:
            "Summary of cash liquidity inflows entering the treasury via approved receipts during the selected period.",
        total_filtered_receipts_tip:
            "Total cash collected within the selected active filter period.",
        max_receipt_tip:
            "The highest single receipt value approved during the current period.",
        min_receipt_tip:
            "The lowest single receipt value approved during the current period.",
        avg_receipts_stream_tip:
            "The average value of cash inflows for receipts during the current period.",
        receipt_inflow_vs_commission_outflow_tip:
            "A visual comparison showing the monthly balance between incoming cash flows (receipts) against accrued commissions (credit).",
        net_profit_saturation_chart_tip:
            "An indicator measuring profit retention efficiency; the percentage of net profit the company keeps after covering beneficiaries' shares.",
        financial_risk_balancing_gap_analysis_tip:
            "A chart displaying the gap and balance scale between credit commissions (company rights) and debit commissions (employee shares).",
        dynamic_employee_financial_performance_tip:
            "Employee financial leaderboard; displays the total credits and debits for each employee filtered by the selected duration.",
        commissions_distribution_by_classification_type_tip:
            "Financial distribution showing commission volumes grouped by real estate or administrative deal classification type.",
        detailed_commissions_deal_by_deal_report_tip:
            "An advanced deal-by-deal report displaying financial statuses and micro beneficiary shares for each contract independently.",
        contract_number_tip:
            "The unique contract number for the deal; click it to copy directly to clipboard.",
        status_tip:
            "The overall financial status of the deal based on the approval workflow of its associated commissions.",
        primary_creditor_tip:
            "The primary employee or broker responsible for closing the contract and securing the deal.",
        total_credit_tip:
            "The total estimated value of the deal's credit commission allocated to the company's master account.",
        total_debit_tip:
            "Total commissions deducted from this deal and owed to other employees and partners.",
        net_profit_tip:
            "The company's net profit from this specific deal after subtracting all beneficiaries' commissions.",
        beneficiary_totals_tip:
            "The final absolute unified total owed to each debit employee in this specific deal, regardless of different sub-status breakdowns.",
        micro_beneficiaries_shares_tip:
            "The precise status of each itemized deduction (Approved ✅, Pending ⏳, Rejected ❌).",
        recent_approved_receipt_requests_tip:
            "A log displaying the latest cash receipts that were approved and entered the organization's fund recently.",
        stage_transitions_tip:
            "Total number of changes and transitions of deal stages from one status to another within the system during the selected period.",
        executed_activities_tip:
            "Total number of individual tasks completed by the team (e.g., calls, meetings, site visits).",
        new_projects_added_tip:
            "Number of newly introduced real estate projects and compounds added to the database recently.",
        new_clients_tip:
            "New leads and clients registered in the system whose communications have initiated during this period.",
        new_developers_tip:
            "Number of new real estate developers or companies partnered with and registered into the system.",
        activity_density_analysis_tip:
            "A chart displaying the volume and density of executed team activities over time to monitor peak business hours.",
        final_closing_rate_tip:
            "Overall conversion success rate; represents the percentage of leads or opportunities successfully converted into sold deals.",
        sold_deals_count_tip:
            "The total number of real estate contracts and units successfully closed and signed.",
        active_deals_tip:
            "Current active deals that are still in progress, under review, or being negotiated and not closed yet.",
        top_3_sales_sources_tip:
            "The top 3 marketing channels or lead generation sources that achieved the highest sales and closing rates for the company.",
        market_gap: {
            title: "Market Gap Analysis (Demand vs Supply - Deficit Gaps Only)",
            subtitle:
                "This analysis displays current actual market deficits, excluding fully covered requests.",
            deficit_badge: "Deficit (Demand without sufficient supply)",
            empty_state:
                "No deficit gaps found in current requests. All demands are fully covered!",
            table: {
                region_district: "Region & District",
                target_request_type: "Target Request Type",
                rooms: "Rooms",
                demands: "Demands (Requests)",
                available: "Available (Supply)",
                gap_status: "Gap Status & Level",
                price_average: "Price Average (Client Budget vs Market)",
                click_to_copy: "Click on contract number to copy",
                deficit_count: "Deficit of {count} units",
                client_budget: "Client Budget:",
                market_supply: "Market Supply:",
                no_inventory_price: "No inventory for pricing",
            },
        },
        download_all_images: "Download All Images",
        need_payment: "Need Payment",
        new_clients: "New Clients",
        current_live_snapshot: "Comprehensive Live Clients Snapshot",
        live_snapshot_desc:
            "Comprehensive and live statistics for all clients in the system (unaffected by search filters)",
        total_clients_now: "Total Clients in System",
        main_stages_now: "Overall Main Stages Distribution",
        bank_sub_stages_now: "Overall Bank Sub-Stages",

        filtered_live_snapshot: "Specific Live Snapshot (User / Role)",
        filtered_snapshot_desc:
            "Live statistics filtered by your choice of user or role (unaffected by date filter)",
        filtered_clients_now: "Clients for Currently Selected",
        main_stages_filtered_now: "Main Stages for Selected",
        bank_sub_stages_filtered_now: "Bank Sub-Stages for Selected",

        users_performance_summary: "Employees Performance Summary",
        users_performance_desc_histories:
            "Detailed view of deals under management and historical new deals count based on logs",
        employee_name: "Employee Name",
        employee_role: "Job Role",
        total_assigned_deals: "Total Managed Deals",
        new_deals_count: "New Deals Count",
        no_users_found: "No users currently registered",

        commissions_earned_completed_sales:
            "Earned Commissions (Completed Sales)",
        expected_commissions_pipeline: "Expected Commissions (Pipeline)",
        sar: "SAR",
        activity_efficiency: "Activity & Performance Efficiency",
        visit_success_rate: "Visit Success Rate",
        call_success_rate: "Call Success Rate",

        pipeline_stages: "Pipeline Stages",
        conversion_efficiency: "Conversion & Success Rates Efficiency",
        sequential_conversion: "Sequential Stage-to-Stage Conversion",
        direct_target_conversion: "Direct Conversion to Final Goal",

        marketing_channel_analysis: "Marketing Channels Analysis",
        marketing_channel_analysis_description:
            "Performance of deal sources and their conversion rates to successful sales",
        incoming_deal: "Incoming Deal",
        sold_deals: "Sold Deal",
        success_rate: "Success Rate",

        payment_methods: "Preferred Payment Methods",
        cash: "Cash",
        bank_finance: "Bank Finance",
        bank_stages_analysis: "Bank Deals Analysis by Stage",
        deals: "Deals",

        lead_quality_and_demographics: "Lead Quality & Demographics",
        avg_seriousness_score: "Average Client Seriousness Score",
        sakani_supported: "Sakani Supported",
        supported: "Supported",
        not_supported: "Not Supported",
        residential_vs_investment:
            "Purchase Purpose (Residential / Investment)",
        nationality_ratio: "Nationality Ratio (Citizen / Resident)",
        deals_by_city: "Deals Distribution by Cities",
        client_count_unit: "Client",

        active_banks_analysis: "Active Banks Analysis",
        top_bank_employees: "Top Active Bank Employees",
        deal_loss_reasons: "Reasons for Deal Loss & Closure",

        // Tooltips Texts
        tooltip_total_clients:
            "Represents the absolute total number of all registered clients in the database without filters.",
        tooltip_filtered_clients:
            "Number of clients assigned to the specific user or role selected in the top filter.",
        tooltip_earned_commissions:
            "Total earned and accrued commissions from successfully closed and completed sales.",
        tooltip_pipeline_commissions:
            "Estimated expected commissions from ongoing deals currently in the pipeline.",
        tooltip_activity_efficiency:
            "Indicator reflecting how effective site visits and phone calls are in advancing deals.",
        tooltip_avg_seriousness:
            "The approximate average seriousness rating of client requests out of 5 stars.",
        tooltip_sakani_support:
            "Distribution of clients eligible for Sakani program support vs non-eligible ones.",
        tooltip_purpose:
            "The ratio of personal residential property requests compared to investment properties.",
        tooltip_nationality:
            "The proportional distribution of citizen clients versus resident clients in the system.",
        cash_deals_desc:
            "Percentage and total count of clients who prefer purchasing via direct cash payment.",
        bank_finance_deals_desc:
            "Percentage and total count of clients whose deals require bank financing.",
        current_live_snapshot_tip:
            "This snapshot displays the total number of clients currently registered in the system and their instant distribution across all main and sub-bank stages without any time filters.",
        filtered_live_snapshot_tip:
            "This snapshot displays real-time client data based on the active filtering criteria you have selected (such as date or employee filters).",
        users_performance_summary_tip:
            "A summary showing the total volume of deals assigned to each employee, highlighting the number of newly added deals to assess current activity.",
        pipeline_stages_tip:
            "A chart showing the workflow movement of deals and their numerical distribution across the main marketing and sales stages.",
        marketing_channel_analysis_tip:
            "Analysis of marketing channel performance by tracking incoming deals and the success rate of each channel in closing deals (sales).",
        bank_stages_analysis_tip:
            "A chart showing the distribution of current real estate transactions within evaluation and approval stages across banks and financing entities.",
        lead_quality_and_demographics_tip:
            "Demographic indicators measuring average lead seriousness score, sakani support ratio, purchase purpose (residential/investment), and nationality.",
        sub_contract_description: "Sub-Contract Description",
        brokerage_contracts_ads: "Brokerage Contracts Ads",
        brokerage_ads_title: "Brokerage & Marketing Contracts Ad Platforms",
        brokerage_ads_subtitle:
            "Track and manage the publishing of real estate units across mandatory and optional advertising platforms, and document licenses.",
        loading: "Loading...",
        refresh: "Refresh Data",
        all: "All",
        completed_required: "Mandatory Platforms Completed",
        never_published: "Never Published",
        missing_required_platforms: "Missing Mandatory Platforms",
        has_contract: "Has Contract / License",
        no_contract: "No Contract",
        all_employees: "All Employees",
        project_unit: "Project / Unit",
        ad_license_column: "Ad License Number",
        ad_contract_column: "Contract Number",
        required_badge: "Mandatory",
        optional_badge: "Optional",
        actions: "Actions",
        no_mediation_projects:
            "No brokerage projects match the selected filters.",
        copy_to_clipboard: "Click to copy unit number",
        no_license_added: "No license added",
        contract_badge: "Contract",
        sub_contract_badge: "Sub-Contract",
        main_contract_description_title: "Main Contract Description",
        sub_contract_description_title: "Sub-Contract Description",
        published: "Published",
        not_published: "Not Published",
        edit_data: "Edit Data",
        add_contract_data: "Add Contract Data",
        manage_links_btn: "Manage Links",
        manage_links_modal_title: "Manage Ad Platform Links",
        cancel: "Cancel",
        saving: "Saving...",
        save_changes: "Save Changes",
        edit_contract_license_modal_title: "Edit Contract & License Data for",
        license_input_label: "Advertising License Number (REGA)",
        search_by_code: "Search by Unit / Contract No.",
        search_placeholder: "Search by unit number or code...",
        contract_description_filter: "Contract Details",
        contract_description_placeholder: "Search contract details...",
        sub_contract_description_filter: "Sub-Contract Details",
        sub_contract_description_placeholder: "Search sub-contracts...",
        ad_platform_status: "Platform Ad Status",
        filter_ad_contract: "Filter by Ad Contract presence",
        filter_by_employee: "Filter by Employee",

        // Dynamic Sale Status Filters
        sale_status_all: "All Statuses",
        sale_status_available: "Available",
        sale_status_sold: "Sold",
        sale_status_reserved: "Reserved",
        sale_status_not_available: "Not Available",

        // Dynamic Contract Type Filters
        contract_type_all: "All Contracts",
        contract_type_exclusive: "Exclusive",
        contract_type_mediation: "Mediation",
        requested_by: "Requested By",
        approval_levels: "Approval Levels",
        detailed_receipts_report: "Detailed Receipts Report",
        detailed_receipts_report_tip:
            "This report displays detailed financial transaction records for receipt requests (credits and debits) made on deals during the specified period, with the ability to track the status of each receipt and its respective issuer.",
        receipts_report_desc:
            "Monitor and audit incoming and outgoing receipt transactions and their approval statuses.",
        receipt_number: "Receipt No. / Client",
        receipt_number_tip:
            "Click on the receipt number to directly open its associated deal details.",
        action_type: "Transaction Type",
        amount: "Amount",
        status: "Status",
        receipt_status_tip:
            "Indicates the current approval stage of the receipt within the document workflow (Approved, Under Review, or Pending).",
        receipt_date: "Date",
        primary_issuer: "Issued By",
        primary_issuer_tip:
            "The employee or user who created and submitted the receipt request in the system.",
        details: "Details / Statement",
        approved: "Approved",
        under_review: "Under Review",
        pending_manager: "Pending Manager",
        pending_finance: "Pending Finance",
        rejected: "Rejected",
        unknown: "Unknown",
        na: "N/A",
        external_show: "External Property",
        external_property: "External Property",
        projects_sales_commission: "Projects Sales Commission",
        mark_as_external_property_desc:
            "Specify if this property belongs to external of the system projects",
        project_commission_status: "Project Commission Status",
        project_commission_debit: "Project Commission Deductions (Debit)",
        project_commission_credit: "Total Project Commission (Credit)",

        sales_commission_status: "Sales Commission Status",
        sales_commission_debit: "Sales Commission Deductions (Debit)",
        sales_commission_credit: "Total Sales Commission (Credit)",

        solutions_commission_status: "Solutions Commission Status",
        solutions_commission_debit: "Solutions Commission Deductions (Debit)",
        solutions_commission_credit: "Total Solutions Commission (Credit)",

        grand_total: "Grand Total",
        view_receipt: "View Receipt",
        receipts_total_debit: "Receipt Total Debit",
        receipts_total_credit: "Receipt Total Credit",
    },
    ar: {
        home: "الرئيسية",
        register: "إنشاء حساب",
        logout: "تسجيل الخروج",
        dashboard: "لوحة المعلومات",
        profile: "الملف الشخصي",
        policies: "السياسات",
        privacy_policy: "سياسة الخصوصية",
        contacts: "للتواصل",
        contact: "تواصل",
        contact_us: "تواصل معنا",
        about: "نبذة عنا",
        search: "بحث",

        users: "المستخدمين",
        roles: "الأدوار",
        role: "دور",
        roles_management: "إدارة الأدوار",
        role_management_of: "إدارة الدور الخاص بـ",

        permissions: "الصلاحيات",
        permission: "صلاحية",
        permissions_management: "إدارة الصلاحيات",

        users_management: "إدارة المستخدمين",

        developers: "المطورين",
        developer: "مطور",
        developers_management: "إدارة المطورين",

        clients: "العملاء",
        client: "عميل",
        clients_management: "إدارة العملاء",

        projects: "المشاريع",
        project: "مشروع",
        projects_management: "إدارة المشاريع",

        communications_and_deals: "الاتصالات والصفقات",
        deal: "الصفقة",
        communications: "الاتصالات",

        next: "التالي",
        previous: "السابق",
        there_is_no_available_data: "لا توجد بيانات متاحة",

        name: "الاسم",
        add: "إضافة",
        edit: "تعديل",
        delete: "حذف",
        activate: "تفعيل",
        deactivate: "تعطيل",
        refresh: "تحديث",
        per_page: "لكل صفحة",
        ex: "مثال",

        display_name: "الاسم المعروض",
        description: "الوصف",
        procedures: "الإجراءات",

        the_name_field_is_required: "حقل الاسم مطلوب",
        the_display_name_field_is_required: "حقل اسم العرض مطلوب",

        select_permission: "اختر صلاحية",
        search_permission: "ابحث عن صلاحية",
        sync_permissions: "مزامنة الصلاحيات",
        sync_roles: "مزامنة الأدوار",

        administrator: "مدير النظام",
        leave_blank_to_keep_current: "اتركه فارغًا للإبقاء على الحالي",
        confirm_password: "تأكيد كلمة المرور",
        new_password_optional: "كلمة مرور جديدة (اختياري)",

        user: "مستخدم",
        full_name: "الاسم الكامل",
        enter_full_name: "أدخل الاسم الكامل",

        are_you_sure_you_want_to_deactivate_the_user:
            "هل أنت متأكد أنك تريد تعطيل المستخدم؟",
        he_will_not_be_able_to_log_in: "لن يتمكن من تسجيل الدخول.",

        are_you_sure_you_want_to_activate_the_user:
            "هل أنت متأكد أنك تريد تفعيل المستخدم؟",
        he_will_be_able_to_log_in: "سيتمكن من تسجيل الدخول.",

        confirm_user_activation: "تأكيد تفعيل المستخدم",
        confirm_user_deactivation: "تأكيد تعطيل المستخدم",

        activation: "التفعيل",
        active: "نشط",
        inactive: "غير نشط",
        all: "الكل",
        sync: "مزامنة",

        created_by: "تم الإنشاء بواسطة",
        updated_by: "تم التحديث بواسطة",
        created_at: "تاريخ الإنشاء",
        updated_at: "تاريخ التحديث",

        address: "العنوان",
        mobile: "الجوال",

        project_no: "رقم المشروع",
        project_name: "اسم المشروع",
        district: "الحي",
        city: "المدينة",

        project_type: "نوع المشروع",
        source_other: "مصدر آخر",

        area: "المساحة",
        price: "السعر",
        rooms: "عدد الغرف",
        bathrooms: "عدد الحمامات",

        discount_type: "نوع الخصم",
        discount: "الخصم",

        ad_license: "رخصة الإعلان",
        location_side: "الاتجاه",
        contract_type: "نوع العقد",

        front: "أمامي",
        back: "خلفي",

        exclusive: "حصري",
        mediation: "وساطة",
        marketing: "تسويق",
        development: "تطوير",

        percentage: "نسبة مئوية",
        fixed: "ثابت",

        advertisement: "إعلان",
        website: "موقع إلكتروني",
        marketing_office: "مكتب تسويق",
        other: "أخرى",

        offers_and_listing: "العروض والإدراج",
        discount_value: "قيمة الخصم",
        listing_info: "معلومات الإدراج",

        links_and_media: "الروابط والوسائط",
        watch_video: "مشاهدة الفيديو",
        google_maps: "خرائط جوجل",

        draft: "مسودة",
        published: "منشور",

        project_details_view: "عرض تفاصيل المشروع",
        system_logs: "سجلات النظام",

        project_status: "حالة المشروع",
        sale_status: "حالة البيع",

        available: "متاح",
        sold: "مباع",
        reserved: "محجوز",
        ready: "جاهز",
        under_construction: "تحت الإنشاء",

        contract_start: "بداية العقد",
        contract_end: "نهاية العقد",

        add_new_unit: "إضافة وحدة جديدة",
        edit_unit: "تعديل الوحدة",

        project_ref: "مرجع المشروع",
        unit_name: "اسم الوحدة",
        unit_index: "فهرس الوحدات",

        source_details: "تفاصيل المصدر",

        contract_period: "مدة العقد",
        period: "الفترة",
        from: "من",
        to: "إلى",

        details: "تفاصيل",

        apartment: "شقة",
        villa: "فيلا",
        twin_house: "بيت مزدوج",
        roof: "روف",
        floor: "طابق",

        side: "الاتجاه",

        map: "خريطة",
        video: "فيديو",

        youtube_link: "رابط يوتيوب",

        current_location: "الموقع الحالي",
        Longitude: "خط الطول",
        Latitude: "خط العرض",

        copy_link: "نسخ الرابط",
        open_in_google_maps: "فتح في خرائط جوجل",

        floor_number: "رقم الطابق",

        main_image: "الصورة الرئيسية",
        other_images: "صور أخرى",

        primary: "أساسي",
        gallery: "المعرض",

        upload_main_image: "رفع الصورة الرئيسية",
        you_can_select_multiple_images_at_once:
            "يمكنك اختيار عدة صور في نفس الوقت",

        data_is_being_uploaded: "جاري رفع البيانات",
        please_wait_the_images_are_currently_being_processed:
            "يرجى الانتظار، يتم معالجة الصور حالياً",

        view_gallery: "عرض المعرض",
        wait_few_seconds_for_result: "انتظر بضع ثوانٍ",

        none: "لا يوجد",

        block: "حظر",
        blacklist: "قائمة سوداء",
        disqualified: "غير مؤهل",
        dnc: "عدم الاتصال",
        new: "جديد",

        block_reasons: "أسباب الحظر",
        status: "الحالة",

        official_site: "الموقع الرسمي",
        snapchat: "سناب شات",
        tiktok: "تيك توك",
        instagram: "إنستغرام",
        facebook: "فيسبوك",

        google_ads: "إعلانات جوجل",
        whatsapp_business: "واتساب للأعمال",
        email_ads: "إعلانات البريد الإلكتروني",
        billboard: "إعلانات لوحة إعلانية",
        sms: "رسائل نصية",

        office_visit: "زيارة المكتب",
        referral_from_client: "إحالة من عميل",
        aqar: "عقار",
        bayut: "بيوت",
        property_finder: "بروبرتي فايندر",
        haraj: "حراج",
        field_employee: "موظف ميداني",
        marketer: "مسوق",

        price_hunter: "باحث عن السعر الأرخص",
        unserious: "غير جاد",
        invalid_information: "معلومات غير صحيحة",
        identity_misrepresentation: "انتحال هوية",
        ghosting: "تجاهل",
        abusive_behavior: "سلوك مسيء",
        no_show_expert: "عدم الحضور",
        do_not_call: "عدم الاتصال",
        spamming: "إزعاج / سبام",
        deal_management: "إدارة الصفقات",
        deals_management: "إدارة الصفقات",
        total_deals: "إجمالي الصفقات",

        current_stage: "المرحلة الحالية",
        current_user: "المستخدم الحالي",

        unknown_client: "عميل مجهول",

        no_transaction_log_yet: "لا يوجد سجل عمليات بعد",
        no_deals_recorded: "لا توجد صفقات مسجلة",

        users_chat: "دردشة المستخدمين",

        from_stage: "من مرحلة",
        to_stage: "إلى مرحلة",

        call: "اتصال",
        visit: "زيارة",
        send: "إرسال",

        last_activities: "آخر الأنشطة",

        contract: "عقد",

        not_distributed_yet: "لم يتم التوزيع بعد",
        loading: "جاري التحميل",

        search_options: "خيارات البحث",
        select_user: "اختر مستخدم",
        select_stage: "اختر المرحلة",
        select_bank_sub_stage: "اختر مرحلة البنك",

        transitioning_options: "خيارات الانتقال",
        transitioning_details: "تفاصيل الانتقال",
        log_new_transitioning: "تسجيل انتقال جديد",
        write_transitioning_note_here: "اكتب ملاحظات الانتقال هنا",
        note_will_be_visible_in_the_transaction_log:
            "ستظهر الملاحظة في سجل العمليات",

        write_developer_name: "اكتب اسم المطور",
        write_city_name: "اكتب اسم المدينة",
        write_district_name: "اكتب اسم الحي",
        write_client_name_or_phone: "اكتب اسم العميل أو رقم الهاتف",

        notes: "ملاحظات",

        log_new_activity: "تسجيل نشاط جديد",
        activity_type: "نوع النشاط",
        activity_details: "تفاصيل النشاط",
        add_activity: "إضافة نشاط",

        what_happened_during_activity: "ماذا حدث أثناء النشاط",
        activity_status: "حالة النشاط",

        success: "ناجح",
        unsuccess: "غير ناجح",

        are_you_sure: "هل أنت متأكد؟",
        do_you_really_want_to_proceed_with_this_action_this_process_cannot_be_undone:
            "هل تريد حقاً المتابعة؟ لا يمكن التراجع عن هذا الإجراء.",

        yes_i_m_sure: "نعم، أنا متأكد",
        no_cancel: "لا، إلغاء",

        documents_and_attachments_of_the_deal:
            "المستندات والمرفقات الخاصة بالصفقة",
        add_new_attachment: "إضافة مرفق جديد",
        edit_attachment: "تعديل المرفق",
        choose_image_or_pdf_file: "اختر صورة أو ملف PDF",

        facade_direction: "اتجاه الواجهة",

        west: "غرب",
        east: "شرق",
        north: "شمال",
        south: "جنوب",

        low_budget: "ميزانية منخفضة",

        client_not_responding: "العميل لا يرد",

        select_closed_sub_stage: "اختر سبب الإغلاق",

        receipt: "إيصال",

        request_new: "طلب جديد",
        total_approved_amount: "إجمالي المبالغ المعتمدة",

        requested_at: "تاريخ الطلب",

        request_receipt_for_deal: "طلب إيصال للصفقة",
        submit_receipt_request: "إرسال طلب الإيصال",

        amount: "المبلغ",

        this_request_will_be_sent_for_review_Once_approved_an_official_document_number_and_approval_date_will_be_issued:
            "سيتم إرسال هذا الطلب للمراجعة، وعند الموافقة سيتم إصدار رقم رسمي وتاريخ اعتماد.",

        approved_by: "تمت الموافقة بواسطة",

        rejection_reason_if_any: "سبب الرفض (إن وجد)",
        write_reason_here: "اكتب السبب هنا",

        approve_and_issue_number: "اعتماد وإصدار رقم",
        reject: "رفض",
        approve: "موافقة",

        review_receipt_request: "مراجعة طلب الإيصال",

        approved_at: "تمت الموافقة في",
        rejected_at: "تم الرفض في",

        submit_request: "إرسال الطلب",

        confirm_approve_receipt: "تأكيد الموافقة على الإيصال",

        no_receipts_found: "لا توجد إيصالات",

        parties: "الأطراف",

        contract_total_commission: "إجمالي عمولة العقد",

        info: "معلومات",
        process_log: "سجل العمليات",

        edit_commission: "تعديل العمولة",
        add_commission: "إضافة عمولة",

        beneficiary: "المستفيد",
        entity: "الجهة",

        choose_beneficiary: "اختر المستفيد",

        commission_type: "نوع العمولة",
        sales_commission: "عمولة مبيعات",
        solutions_commission: "عمولة حلول",

        project_commission: "عمولة المشروع",

        amount_due: "المبلغ المستحق",

        example_external_brokers_share: "مثال: حصة الوسيط الخارجي",

        update_data: "تحديث البيانات",

        distribution_adoption: "اعتماد التوزيع",
        date_awarded: "تاريخ منح العمولة",

        commissions_distribution: "توزيع العمولات",

        review_and_approval: "مراجعة واعتماد",

        print_receipt: "طباعة الإيصال",

        add_role: "إضافة دور",
        add_permission: "إضافة صلاحية",

        no_permissions_have_been_selected_yet: "لم يتم اختيار أي صلاحيات بعد",
        saving: "جاري الحفظ",
        successfully: "تم بنجاح",

        no_permissions_selected_yet: "لا توجد صلاحيات مختارة",

        search_and_add_permission: "ابحث وأضف صلاحية",

        action: "الإجراء",
        select_reason: "اختر السبب",
        optional: "اختياري",

        add_new_deal: "إضافة صفقة جديدة",

        queries_and_deals: "الاستعلامات والصفقات",
        queries: "الاستعلامات",

        reports: "التقارير",
        report: "تقرير",

        payment_method: "طريقة الدفع",
        select_payment_method: "اختر طريقة الدفع",

        cash: "نقدي",
        bank: "بنك",

        leave_blank: "اتركه فارغاً",

        Sorry_access_denied: "عذراً، تم رفض الوصول",

        you_do_not_have_sufficient_permissions_to_view_this_page_If_you_believe_this_is_an_error_please_contact_your_system_administrator:
            "ليس لديك صلاحيات كافية لعرض هذه الصفحة. إذا كنت تعتقد أن هذا خطأ، يرجى التواصل مع مسؤول النظام.",

        back_to_home: "العودة للرئيسية",
        return_to_the_previous_page: "العودة للصفحة السابقة",
        contract_number: "رقم العقد",
        client_number: "رقم العميل",

        all_stages: "جميع المراحل",
        close_sub_stage: "مرحلة الإغلاق",
        bank_sub_stage: "مرحلة البنك",

        all_sources: "جميع المصادر",

        contract_date_from: "تاريخ العقد من",
        contract_date_to: "تاريخ العقد إلى",

        created_at_from: "تاريخ الإنشاء من",
        created_at_to: "تاريخ الإنشاء إلى",

        at: "في",
        filter: "تصفية",

        active_status_now: "نشط حالياً",
        inactive_status_now: "غير نشط حالياً",

        complete_documentation: "استكمال الوثائق",
        completed: "مكتمل",
        incomplete: "غير مكتمل",

        documents: "المستندات",
        reset: "إعادة تعيين",

        delay_days: "أيام التأخير",

        phone: "هاتف",
        since_last_activity: "منذ آخر نشاط",

        daily: "يومي",
        weekly: "أسبوعي",
        monthly: "شهري",
        quarterly: "ربع سنوي",
        semi_annual: "نصف سنوي",
        annual: "سنوي",
        custom_period: "فترة مخصصة",

        all_roles: "جميع الأدوار",
        all_users: "جميع المستخدمين",

        overview: "نظرة عامة",

        sales_reports: "تقارير المبيعات",
        finance_reports: "التقارير المالية",

        real_estate_inventory: "مخزون العقارات",
        performance: "الأداء",

        stage_transitions: "انتقالات المراحل",
        executed_activities: "الأنشطة المنفذة",

        new_projects_added: "مشاريع جديدة مضافة",
        new_clients: "عملاء جدد",
        new_developers: "مطورون جدد",

        activity_density_analysis: "تحليل كثافة النشاط",

        by: "بواسطة",

        smart_time_comparison: "مقارنة زمنية ذكية",

        activities_count: "عدد الأنشطة",

        no_activities_recorded_period: "لا توجد أنشطة مسجلة لهذه الفترة",

        final_closing_rate: "معدل الإغلاق النهائي",

        updated_based_on_sold_deals: "محدث بناءً على الصفقات المباعة",

        sold_deals_count: "عدد الصفقات المباعة",

        active_deals: "الصفقات النشطة",

        top_3_sales_sources: "أفضل 3 مصادر مبيعات",

        sold_deal_unit: "وحدة الصفقة المباعة",

        no_sales_data_currently: "لا توجد بيانات مبيعات حالياً",

        commissions_and_profits_analysis: "تحليل العمولات والأرباح",

        total_commissions: "إجمالي العمولات",

        highest_commission_recorded: "أعلى عمولة مسجلة",
        lowest_commission_recorded: "أقل عمولة مسجلة",
        average_commissions: "متوسط العمولات",

        collected_cash_flow_analysis: "تحليل التدفقات النقدية",

        total_actually_collected: "إجمالي المقبوضات",

        highest_receipt: "أعلى إيصال",
        lowest_receipt: "أقل إيصال",
        average_receipts: "متوسط الإيصالات",

        commission_growth_performance: "نمو أداء العمولات",
        commission_distribution: "توزيع العمولات",

        from_developer: "من المطور",
        from_client: "من العميل",

        employees_performance_commissions: "أداء الموظفين في العمولات",

        top_collecting: "الأكثر تحصيلاً",

        latest_accepted_receipts: "آخر الإيصالات المقبولة",

        receipt_no: "رقم الإيصال",

        top_selling_district: "الحي الأكثر مبيعاً",
        highest_average_price: "أعلى متوسط سعر",

        in: "في",

        units_available_for_sale_now: "وحدات متاحة للبيع الآن",
        total_units_sold: "إجمالي الوحدات المباعة",
        units_waiting_for_procedures: "وحدات بانتظار الإجراءات",

        sell_through_rate: "معدل البيع",

        distribution_of_added_units_by_selected_period:
            "توزيع الوحدات المضافة حسب الفترة المحددة",

        total: "إجمالي",
        unit: "وحدة",

        developer_performance: "أداء المطور",

        sales: "المبيعات",

        district_details: "تفاصيل الحي",
        district_name: "اسم الحي",

        average_area: "متوسط المساحة",
        average_price: "متوسط السعر",

        m2: "م²",

        inventory_analysis_by_property_type: "تحليل المخزون حسب نوع العقار",

        property_type: "نوع العقار",

        contract_type_distribution: "توزيع أنواع العقود",

        sources: "المصادر",

        inactive_units: "وحدات غير نشطة",
        archived_or_inactive_units: "وحدات مؤرشفة أو غير نشطة",

        top_performer: "أفضل أداء",
        close_rate: "معدل الإغلاق",

        deals_transfer_report: "تقرير انتقال الصفقات",
        track_deals_movement_description: "متابعة حركة الصفقات",

        total_transfers: "إجمالي التحويلات",

        latest_transfer_notes: "آخر ملاحظات التحويل",

        agents_ranking_by_sales: "ترتيب الوكلاء حسب المبيعات",

        live_update: "تحديث مباشر",

        agent: "وكيل",

        successful_operations: "العمليات الناجحة",
        conversion_rate: "معدل التحويل",

        commissions_earned: "العمولات المكتسبة",

        daily_activity_indicators: "مؤشرات النشاط اليومي",

        attempts_per_sale: "متوسط المحاولات لكل صفقة مباعه",

        smart_numbers_insight: "تحليل الأرقام الذكية",

        active_agent: "الوكيل النشط",
        active_agent_description: "وصف الوكيل النشط",

        followup_quality: "جودة المتابعة",
        followup_quality_description: "وصف جودة المتابعة",

        reception: "الاستقبال",
        reception_description: "وصف الاستقبال",

        pipeline_stages: "مراحل القمع البيعي",
        conversion_efficiency: "كفاءة التحويل",

        payment_methods: "طرق الدفع",

        bank_finance: "تمويل بنكي",
        bank_stages_analysis: "تحليل مراحل البنك",

        deal_loss_reasons: "أسباب خسارة الصفقات",

        account_settings: "إعدادات الحساب",
        profile_settings: "إعدادات الملف الشخصي",
        profile_settings_description: "وصف إعدادات الملف الشخصي",

        danger_zone: "منطقة الخطر",

        two_factor_authentication: "المصادقة الثنائية",
        two_factor_description: "المصادقة الثنائية هي طبقة أمان إضافية...",

        two_factor_enabled_title: "المصادقة الثنائية مفعلة",
        finish_enabling_two_factor: "إكمال تفعيل المصادقة الثنائية",
        two_factor_not_enabled_title: "المصادقة الثنائية غير مفعلة",
        two_factor_info_text: "معلومات عن المصادقة الثنائية",

        qr_code_confirm_instruction: "امسح رمز QR باستخدام تطبيق المصادقة",

        qr_code_enabled_instruction: "تم تفعيل رمز QR الخاص بك",

        setup_key: "مفتاح الإعداد",
        code: "الرمز",

        recovery_codes_instruction:
            "يمكنك استخدام رموز الاسترداد عند فقدان الجهاز",

        enable: "تفعيل",
        confirm: "تأكيد",

        regenerate_recovery_codes: "إعادة إنشاء رموز الاسترداد",
        show_recovery_codes: "عرض رموز الاسترداد",
        disable: "تعطيل",

        update_password: "تحديث كلمة المرور",
        update_password_description: "تحديث كلمة المرور",

        current_password: "كلمة المرور الحالية",
        new_password: "كلمة المرور الجديدة",

        saved: "تم الحفظ",

        browser_sessions: "جلسات المتصفح",
        browser_sessions_description: "إدارة جلسات المتصفح",
        browser_sessions_content: "محتوى جلسات المتصفح",

        unknown: "غير معروف",
        this_device: "هذا الجهاز",
        last_active: "آخر نشاط",

        log_out_other_browser_sessions: "تسجيل الخروج من الجلسات الأخرى",

        done: "تم",

        log_out_confirm_message:
            "هل أنت متأكد من تسجيل الخروج من جميع الجلسات؟",

        delete_account: "حذف الحساب",
        permanently_delete_your_account: "حذف الحساب نهائياً",

        delete_account_confirmation_message: "تأكيد حذف الحساب",
        delete_account_warning_text: "تحذير حذف الحساب",

        profile_information: "معلومات الملف الشخصي",
        update_profile_description: "تحديث الملف الشخصي",

        photo: "صورة",
        select_a_new_photo: "اختر صورة جديدة",
        remove_photo: "إزالة الصورة",

        email_unverified: "البريد غير مفعل",
        resend_verification_email: "إعادة إرسال التحقق",
        verification_link_sent: "تم إرسال رابط التحقق",

        client_evaluation: "تقييم العميل",
        blocked_clients_analysis: "تحليل العملاء المحظورين",
        quality_alert: "تنبيه الجودة",

        price_hunters_description: "وصف الباحثين عن أقل سعر",

        missed_opportunities: "فرص ضائعة",
        ghosting_or_invalid_info: "تجاهل أو معلومات غير صحيحة",

        top_block_reason_this_week: "أكثر أسباب الحظر هذا الأسبوع",

        clients_count: "عدد العملاء",

        channel_efficiency: "كفاءة القنوات",
        top_conversion: "أعلى تحويل",

        lead_source_analysis: "تحليل مصدر العملاء المحتملين",
        track_marketing_performance: "متابعة أداء التسويق",

        import_excel: "استيراد Excel",

        follow_up: "متابعة",
        interested: "مهتم",
        field_visit: "زيارة ميدانية",
        reservation: "الحجز",

        waiting_for_transfer: "بانتظار الإفراغ",

        no_data_found: "لا توجد بيانات",

        north_east: "شمال شرق",
        north_west: "شمال غرب",
        south_east: "جنوب شرق",
        south_west: "جنوب غرب",
        north_south: "شمال جنوب",
        east_west: "شرق غرب",

        location_link: "رابط الموقع",

        new_to_sold: "من جديد إلى مباع",
        visit_to_sold: "من زيارة إلى مباع",
        bank_to_closed: "من البنك إلى مغلق",

        adsplatforms: "منصات الإعلانات",

        access_token: "رمز الوصول",
        enter_access_token: "أدخل رمز الوصول",

        update_platform: "تحديث المنصة",
        add_new_platform: "إضافة منصة جديدة",

        token: "الرمز",
        actions: "الإجراءات",
        platform: "المنصة",
        select_platform: "اختر المنصة",

        confirm_delete_text:
            "هل أنت متأكد من حذف هذه المنصة؟ لا يمكن التراجع عن هذا الإجراء.",

        yes_delete: "نعم، احذف",
        deleted_successfully: "تم الحذف بنجاح",

        contract_description: "وصف العقد",
        deal_details: "تفاصيل الصفقة",

        please_enter_rejection_reason: "يرجى إدخال سبب الرفض",

        finance_calculator: "حاسبة التمويل",

        choose_client: "اختر العميل",

        management_and_queries: "الإدارة والاستعلامات",
        crm: "إدارة علاقات العملاء",

        example: "مثال",

        bathrooms_count: "عدد الحمامات",
        max_price: "السعر الأقصى",
        area_m2: "المساحة (م²)",
        rooms_count: "عدد الغرف",

        smart_advanced_query_engine: "محرك البحث الذكي المتقدم",

        natural_language_search_placeholder: "اكتب استعلامك بلغة طبيعية...",

        example_yasmin_villa: "مثال: فيلا ياسمين",

        street_or_district_name: "اسم الشارع أو الحي",

        apply_search: "تطبيق البحث",

        not_available: "غير متوفر",

        download_pdf: "تحميل PDF",

        querying: "جاري البحث",

        location: "الموقع",

        hide_filters: "إخفاء الفلاتر",
        filter_and_search: "تصفية وبحث",
        refresh_board: "تحديث اللوحة",

        advanced_search: "بحث متقدم",

        task_scheduling: "جدولة المهام",

        today_tasks: "مهام اليوم",
        tomorrow_tasks: "مهام الغد",
        week_tasks: "مهام الأسبوع",
        past_tasks: "المهام السابقة",

        last_activity: "آخر نشاط",
        schedule_date: "تاريخ الجدولة",
        creation_date: "تاريخ الإنشاء",

        delayed: "متأخر",
        days: "أيام",

        no_project: "لا يوجد مشروع",

        sort_by: "ترتيب حسب",

        loading_data: "جاري تحميل البيانات",

        bank_stage: "مرحلة البنك",
        close_stage: "مرحلة الإغلاق",

        property_details: "تفاصيل العقار",
        edit_property: "تعديل العقار",

        change: "تغيير",

        smart_client_evaluation_system: "نظام تقييم العملاء الذكي",

        update_seriousness_criteria_hint: "تحديث معايير الجدية",
        perform_new_evaluation: "إجراء تقييم جديد",

        postponing_purchase: "تأجيل الشراء",
        purchasing_from_another_company: "الشراء من شركة أخرى",
        property_unavailable: "العقار غير متوفر",
        area_unavailable: "المنطقة غير متوفرة",

        not_eligible_for_financing: "غير مؤهل للتمويل",
        unresponsive_client: "عميل غير متجاوب",

        incorrect_information: "معلومات غير صحيحة",
        does_not_respond: "لا يرد",
        not_interested: "غير مهتم",

        contracted: "متعاقد",
        initial_approval: "موافقة أولية",
        appraisal: "تقييم",
        issuing_contracts: "إصدار العقود",
        signing_contracts: "توقيع العقود",
        issuing_check: "إصدار شيك",
        waiting_transfer: "بانتظار التحويل",
        closed: "مغلق",

        automated_system: "نظام آلي",

        last_update: "آخر تحديث",

        no_attachments_found: "لا توجد مرفقات",
        no_commission_data_found: "لا توجد بيانات عمولات",

        cancel: "إلغاء",
        save: "حفظ",
        update: "تحديث",

        points: "نقاط",

        rejection_reason: "سبب الرفض",

        transaction_log: "سجل العمليات",

        no_reason_provided: "لا يوجد سبب",

        additional_details: "تفاصيل إضافية",

        client_seriousness_analysis: "تحليل جدية العميل (نظام النقاط الذكي)",

        requirements_clarity: "وضوح المتطلبات",
        precisely_defined: "محدد بدقة",
        vague: "غير واضح",

        inspection_questions_quality: "جودة أسئلة المعاينة",
        technical_legal_questions: "أسئلة تقنية/قانونية",
        general_superficial_questions: "أسئلة عامة سطحية",

        purchase_timeline: "المدة المتوقعة للشراء",
        within_month: "خلال شهر",
        three_to_six_months: "3-6 أشهر",
        exploration: "استكشاف",

        payment_method_readiness: "الجاهزية المالية",
        cash_bank_approval: "كاش / موافقة بنكية",
        financing_not_started: "تمويل لم يبدأ",
        housing_support: "دعم سكني (150 ألف)",

        supported_eligible: "مدعوم ومؤهل",

        price_offer_logic: "منطق العرض السعري",
        logical_flexible: "منطقي ومرن",
        unrealistic_not_serious: "غير منطقي / غير جاد",

        response_commitment: "الالتزام بالرد",
        committed_fast_response: "ملتزم وسريع",
        procrastination_disappearance: "تسويف واختفاء",

        decision_maker_presence: "وجود صاحب القرار",
        brought_partner: "أحضر الشريك",
        always_alone: "دائمًا بمفرده",

        client_notes: "ملاحظات العميل",

        golden_client_ready: "عميل ذهبي - جاهز للإغلاق",
        serious_client_followup: "عميل جاد - يحتاج متابعة",
        cold_client_exploring: "عميل بارد - مرحلة استكشاف",

        advanced_unit_query: "استعلام متقدم للوحدة",

        real_estate_summary: "ملخص النشاط العقاري والمبيعات",

        total_yesterday_work: "إجمالي عمل الأمس",

        yesterday_activities: "أنشطة الأمس",
        from_activities_table: "من جدول الأنشطة",

        yesterday_transitions: "تحويلات الأمس",
        from_transitions_log: "من سجل التحويلات",

        today_scheduled: "مهام اليوم",
        based_on_schedule: "حسب الجدولة",

        total_funnel: "إجمالي القمع البيعي",

        latest_deals_week: "أحدث صفقات الأسبوع",
        last_7_days: "آخر 7 أيام",

        stage: "المرحلة",
        date_added: "تاريخ الإضافة",

        no_deals_week: "لا توجد صفقات هذا الأسبوع",

        pipeline_analysis: "تحليل خط المبيعات",

        save_activity_and_schedule: "حفظ النشاط والجدولة",

        activities_and: "الأنشطة و",
        transitions: "التحويلات",

        market_stats_summary: "ملخص إحصائيات السوق",
        based_on_current_results: "بناءً على نتائج البحث الحالية",

        price_range: "نطاق السعر",
        currency_sar: "العملة: ريال سعودي",
        sar_unit: "ر.س",

        area_distribution: "توزيع المساحات",
        unit_sqm: "متر مربع",
        sqm_unit: "م²",

        no_results_found: "لا توجد نتائج",

        median: "الوسيط",
        minimum: "الأدنى",
        maximum: "الأعلى",

        choose_city: "اختر مدينة",
        choose_district: "اختر حي",
        choose_property_type: "اختر نوع العقار",

        results: "النتائج",
        choose_price_range: "اختر نطاق السعر",

        my_clients: "عملائي",

        today: "اليوم",
        tomorrow: "غدًا",
        yesterday: "أمس",

        next_week: "الأسبوع القادم",
        last_week: "الأسبوع الماضي",

        all_employees: "جميع الموظفين",

        this_account_is_inactive_please_check_with_the_system_administrator:
            "هذا الحساب غير مفعل، يرجى مراجعة مدير النظام.",
        the_provided_credentials_are_incorrect: "البيانات المقدمة غير صحيحة",
        failed_to_log_in_Please_try_again_later:
            "فشل في تسجيل الدخول. يرجى المحاولة مرة أخرى لاحقًا.",
        email_address_field_required: "حقل عنوان البريد الإلكتروني مطلوب.",
        the_provided_email_address_is_not_valid:
            "عنوان البريد الإلكتروني المقدم غير صالح.",
        password_field_required: "حقل كلمة المرور مطلوب.",
        login_failed: "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",

        welcome_back: "مرحباً بك مجدداً!",
        login_subtitle: "الرجاء إدخال بياناتك للوصول إلى لوحة التحكم",
        email: "البريد الإلكتروني",
        enter_email: "name{'@'}company.com",
        password: "كلمة المرور",
        enter_password: "••••••••",
        forgot_password: "نسيت كلمة المرور؟",
        remember_me: "تذكر تسجيل دخولي",
        login: "تسجيل الدخول",
        logging_in: "جاري الدخول...",
        success_login: "تم تسجيل الدخول بنجاح! جاري التوجيه...",
        system_footer: "جميع الحقوق محفوظة للنظام السحابي.",
        hero_title: "إدارة الصفقات العقارية والعملاء بذكاء وسرعة فائقة.",
        hero_subtitle:
            "نظام متكامل صمم خصيصاً لمتابعة المؤشرات والتحليلات اليومية وتسهيل مهام فريق المبيعات في بيئة عمل سريعة ومنظمة.",
        secure_badge: "مؤمن بالكامل ومشفر طبقا للمعايير العالمية",
        system_badge: "النظام العقاري",
        copy_to_clipboard: "نسخ إلى الحافظة",
        all_projects: "جميع المشاريع",
        has_location: "يملك موقع",
        description_keywords_search_placeholder:
            "ابحث في وصف المشروع باستخدام كلمات مفتاحية...",
        no_location: "لا يملك موقع",
        assigned_projects: "المشاريع المسندة",
        choose_employee: "اختر موظف",
        assign_permission: "إسناد الصلاحية",
        cancel_assign: "إلغاء الإسناد",
        sold_deals: "المبيعات المكتملة",
        incoming_deal: "الصفقات الواردة",
        marketing_channel_analysis_description: "تحليل القنوات التسويقية",
        marketing_channel_analysis: "تحليل القنوات التسويقية",
        call_success_rate: "معدل نجاح المكالمات",
        visit_success_rate: "معدل نجاح الزيارات",
        activity_efficiency: "كفاءة الأنشطة",
        expected_commissions_pipeline: "أنابيب المكافآت المتوقعة",
        get_matching_projects: "الحصول على المشاريع المطابقة",
        commissions_earned_completed_sales:
            "المكافآت المكتسبة - المبيعات المكتملة",
        delete_message: "حذف الرسالة",
        current_deals: "الصفقات الحالية",
        sold_units: " الوحدات المباعة",
        my_pending_commissions: "المكافآت المعلقة",
        my_sales_funnel: "قمع المبيعات",
        no_recent_activities: "لا توجد أنشطة مسجلة مؤخراً",
        highest_density_stock: "أعلى كثافة مخزون",
        units_displayed: "الوحدات المعروضة",
        stagnant_inventory: "المخزون المتوقف",
        stagnant_inventory_description:
            "الوحدات التي كانت على السوق لفترة طويلة دون اهتمام أو نشاط كبير",
        complexes_and_project_buildings: "المعقدات والمجمعات",
        total_inventory: "إجمالي المخزون",
        inventory_analysis_by_district: "تحليل المخزون حسب المقاطعة",
        monitoring_available_inventory_density_against_past_sales:
            "مراقبة كثافة المخزون المتاح مقابل المبيعات السابقة",
        including_the_uncovered_neighborhoods_within_the_same_city:
            "بما في ذلك الأحياء غير المغطاة داخل نفس المدينة",
        no_projects_added: "لا توجد مشاريع مضافة",
        available_for_sale: "متاح للبيع",
        opportunity_uncovered_investment: "فرصة استثمار غير مغطاة",
        average_price_and_area: "المتوسط السعر والمساحة",
        targeted_neighborhood: "الحي المستهدف",
        for_investment_expansion_and_to_attract_real_estate_offers:
            "لتوسيع الاستثمارات وجلب عروض العقارات",
        displayed_density: "كثافة المعروضة",
        m: "م",
        stock_density: "كثافة المخزون",
        monthly_unit_flow_rate: "معدل تدفق الوحدات الشهرية",
        annual_unit_flow_rate: "معدل تدفق الوحدات السنوية",
        weekly_unit_flow_rate: "معدل تدفق الوحدات الأسبوعية",
        daily_available_units_flow_rate: "معدل تدفق الوحدات المتاحة يومياً",
        available_inventory_liquidity: "سيولة المخزون المتاح",
        no_data_available: "لا توجد بيانات متاحة",
        all_types_of_construction: "جميع أنواع البناء",
        from_the_clients_of_the_kinetic_system: "من عملاء النظام الحركي",
        without: "بدون",
        transfers: "التحويلات",
        projects_added: "المشاريع المضافة",
        developers_added: "المطورين المضافة",
        clients_added: "العملاء المضافة",
        next_contact_date: "تاريخ الاتصال التالي",
        update_schedule: "تحديث الجدولة",
        schedule_next_contact: "جدولة الاتصال التالي",
        reservation_to_sold: "تحويل الحجز إلى البيع",
        seriousness_score: "جدية العميل",
        transiting_all_deals: "تحويل جميع الصفقات",
        selected_deals: "الصفقات المحددة",
        select_all_projects: "تحديد جميع المشاريع",
        selected_projects: "المشاريع المحددة",
        select_targeted_employee: "تحديد الموظف المستهدف",
        system_configuration: "تكوين النظام",
        manage_company_identity_and_settings: "إدارة هوية الشركة وإعداداتها",
        loading_settings: "جاري تحميل الإعدادات",
        company_name: "اسم الشركة",
        enter_company_name: "أدخل اسم الشركة",
        company_logo: "شعار الشركة",
        drag_or_click_to_upload_logo: "اسحب أو انقر لرفع الشعار",
        company_stamp: "ختم الشركة",
        drag_or_click_to_upload_stamp: "اسحب أو انقر لرفع الختم",
        save_settings: "حفظ الإعدادات",
        settings_saved_successfully: "تم حفظ الإعدادات بنجاح",
        validation_error_please_check_fields:
            "خطأ في التحقق، يرجى مراجعة الحقول",
        something_went_wrong: "حدث خطأ ما",
        commercial_register: "السجل التجاري",
        enter_commercial_register: "أدخل السجل التجاري",
        tax_number: "الرقم الضريبي",
        enter_tax_number: "أدخل الرقم الضريبي",
        enter_phone_number: "أدخل رقم الهاتف",
        unit_link: "رابط الوحدة",
        discover_more: "اكتشف المزيد",
        banks: "بنك",
        activities: "الأنشطة",
        edit_activity: "تعديل النشاط",
        commission: "العمولة",
        sort_latest: "فرز حسب الأحدث",
        sort_oldest: "فرز حسب الأقدم",
        sort_highest_commission: "فرز حسب أعلى عمولة",
        sort_lowest_commission: "فرز حسب أدنى عمولة",
        sort_highest_price: "فرز حسب أعلى سعر",
        sort_lowest_price: "فرز حسب أدنى سعر",
        sort_largest_area: "فرز حسب أكبر مساحة",
        select_bank_name: "اختر اسم البنك",
        banks_management: "إدارة البنوك",
        add_bank: "إضافة بنك",
        bank_name: "اسم البنك",
        bank_code: "رمز البنك",
        add_employee: "إضافة موظف",
        rating: "التقييم",
        employees_of: "موظفو",
        edit_bank: "تعديل بنك",
        add_new_employee: "إضافة موظف جديد",
        enter_employee_name: "أدخل اسم الموظف",
        rating_out_of_10: "التقييم (من 10)",
        profit_rate: "معدل الربح",
        search_banks: "بحث في البنوك",
        bank_employee: "موظف البنك",
        edit_deal: "تعديل الصفقة",
        no_data: "لا توجد بيانات",
        whatsapp_welcome_message: "رسالة ترحيب واتساب",
        enter_whatsapp_welcome_message: "أدخل رسالة ترحيب واتساب",
        closed_or_no_signal: "الخط مغلق / خارج التغطية",
        bad_timing: "التوقيت غير مناسب",
        callback_no_reply: "طلب معاودة الاتصال لاحقاً ولم يرد",
        line_busy: "الخط مشغول (مكالمة أخرى)",
        call_cancelled: "تم إنهاء المكالمة (كنسَل)",
        no_answer: "الهاتف يرن دون إجابة",
        requested_callback_later: "طلب مكالمة لاحقاً (ولم يرد)",
        whatsapp_only: "طلب التواصل واتساب فقط",
        wrong_number: "الرقم خاطئ / لا يوجد واتساب",
        wrong_person: "الرقم يخص شخصاً آخر",
        sequential_conversion: "معدلات المراحل المتسلسلة",
        direct_target_conversion: "معدلات التحويل المباشرة للمحطات المستهدفة",
        new_to_followup: "من جديد إلى متابعة",
        followup_to_interested: "من متابعة إلى مهتم",
        interested_to_visit: "من مهتم إلى زيارة ميدانية",
        visit_to_reservation: "من زيارة ميدانية إلى حجز",
        reservation_to_bank: "من حجز إلى بنك",
        bank_to_sold: "من بنك إلى مباع",
        any_to_visit: "معدل التحويل من أي مرحلة إلى زيارة ميدانية",
        any_to_reservation: "معدل التحويل من أي مرحلة إلى الحجز",
        any_to_bank: "معدل التحويل من أي مرحلة إلى البنك",
        any_to_sold: "معدل التحويل من أي مرحلة إلى مباع",
        any_to_closed: "معدل التحويل من أي مرحلة إلى مغلق",
        lead_quality_and_demographics: "جودة وتصنيف الصفقات الحالية",
        avg_seriousness_score: "متوسط درجة الجدية",
        sakani_supported: "دعم سكني",
        residential_vs_investment: "الهدف من الشراء",
        nationality_ratio: "نسبة الجنسية",
        purpose_ratio_format: "{residential} سكن / {investment} استثمار",
        nationality_ratio_format: "{citizen} مواطن / {resident} مقيم",
        deals_by_city: "توزيع العملاء والصفقات حسب المدن",
        client_count_unit: "عميل",
        active_banks_analysis: "تحليل البنوك النشطة الأكثر تعاملاً",
        deals: "صفقات",
        top_bank_employees: "موظفي البنوك الأكثر نشاطاً وتفاعلاً",
        all_sub_stage: "جميع المراحل الفرعية",
        all_banks: "جميع البنوك",
        current_live_snapshot: "اللقطة الحية الحالية",
        live_snapshot_desc:
            "هذه اللقطة تعكس الحالة الحالية للصفقات النشطة في النظام، مع التركيز على مراحل البنك والمراحل الفرعية ذات الصلة. يتم تحديث هذه البيانات بشكل مستمر لتوفير رؤية دقيقة لأداء الصفقات في الوقت الفعلي.",
        main_stages_now: "جميع المراحل الرئيسية",
        bank_sub_stages_now: "جميع المراحل الفرعية للبنك",
        total_clients_now: "جميع العملاء حالياً",
        external_marketer: "المسوق الخارجي",
        duplicated_clients: "العملاء المكررون",
        undefined: "غير محدد",
        unit_number: "رقم الوحدة",
        register_new_field_visit: "تسجيل زيارة ميدانية جديدة",
        comprehensive_failure_reasons_analysis:
            "تحليل أسباب عدم النجاح الشاملة",
        view_stats_and_table: "عرض الإحصائيات والجدول",
        add_new_visit: "إضافة زيارة جديدة +",
        loading_stats: "جاري جلب الإحصائيات...",
        visit_result: "نتيجة الزيارة",
        successful_visit: "ناجحة",
        failed_visit: "غير ناجحة",
        failure_reason_label: "سبب عدم النجاح",
        select_specific_reason: "اختر السبب المحدد",
        additional_notes: "ملاحظات إضافية",
        write_notes_here: "اكتب الملاحظات هنا...",
        save_visit_data: "حفظ بيانات الزيارة",
        total_visits: "إجمالي الزيارات",
        successful_visits: "زيارات ناجحة",
        failed_visits: "زيارات غير ناجحة",
        failure_reasons_and_total_counts:
            "قائمة أسباب عدم النجاح والتكرار الإجمالي:",
        loading_and_preparing_reasons_table:
            "جاري تحميل وتجهيز جدول الأسباب...",
        close: "إغلاق",
        warning: "تنبيه",
        please_select_failure_reason: "الرجاء اختيار سبب عدم النجاح المعين",
        added_successfully: "تمت الإضافة",
        visit_registered_successfully: "تم تسجيل الزيارة بنجاح",
        error: "خطأ",
        error_saving_visit: "حدث خطأ أثناء حفظ بيانات الزيارة",

        price_too_high: "السعر مرتفع جداً",
        area_too_small: "المساحة صغيرة جداً",
        poor_finishing: "التشطيب سيء",
        unsuitable_location: "الموقع غير مناسب",
        no_bank_surplus: "لا يوجد فائض بنكي",
        narrow_street: "الشارع ضيق",
        no_maid_room: "لا توجد غرفة خادمة",
        no_driver_room: "لا توجد غرفة سائق",
        single_entrance: "مدخل واحد فقط",
        no_majlis_partition: "لا يوجد قاطع للمجلس",
        open_kitchen: "مطبخ مفتوح (أمريكي)",
        closed_kitchen: "مطبخ مغلق",
        only_one_elevator: "مصعد واحد فقط",
        reset_filters: "إعادة تعيين الفلاتر",
        advanced_filters: "أدوات التصفية المتقدمة",
        all_contracts: "جميع العقود",
        filtered_live_snapshot: "التقرير اللحظي المفلتر",
        filtered_snapshot_desc: "وصف التقرير اللحظي المفلتر",
        filtered_clients_now: "العملاء الحاليون بالفلاتر",
        users_performance_summary: "ملخص أداء الموظفين",
        users_performance_desc:
            "وصف أداء وإنتاجية فريق العمل خلال الفترة الحالية",
        employee_role: "الدور الوظيفي للموظف",
        total_assigned_clients: "إجمالي العملاء تحت الإدارة",
        new_clients_count: "عدد العملاء الجدد",
        admin: "مسؤول النظام",
        ceo: "المدير التنفيذي",
        sales_manager: "مدير المبيعات",
        sales_employee: "موظف مبيعات",
        sales_field: "موظف ميداني",
        need_calculation: "يحتاج حسبه",
        notifications: "الاشعارات",
        no_new_notifications: "لا يوجد اشعارات جديده",
        mark_as_read: "تحديد كمقروء",
        open: "فتح",
        mark_all_read: "تحديد الكل كمقروء",
        selling_stage: "طريقة الدفع",
        call_status: "حالة الاتصال",
        next_call: "الاتصال التالي",
        chat_title: "الدردشات الرقمية",
        broadcast_title: "المحادثة الجماعية العامة",
        online_count: "متصل الآن بالمنصة",
        online_now: "متصل الآن",
        click_to_chat: "انقر لبدء محادثة ممتعة",
        change_theme: "تغيير مظهرك الإبداعي",
        new_chat: "محادثة جديدة",
        general_chat: "المحادثة العامة",
        pinned: "مثبتة",
        broadcast_subtitle: "رسالة جماعية لكافة موظفي الشركة المبدعين",
        no_chats: "لا توجد محادثات نشطة حالياً",
        no_chats_hint: "اضغط على زر (+) في الأعلى لبدء محادثة جديدة ولطيفة",
        active_now: "نشط الآن",
        click_to_talk: "اضغط للدردشة",
        write_message: "اكتب رسالة رائعة...",
        search_placeholder: "البحث عن موظف متميز...",
        no_users_found: "لا يوجد موظفين متطابقين مع البحث",
        send_message: "إرسال",
        chat_with: "مراسلة",
        delete_confirm: "هل تريد حذف هذه الرسالة لدى الجميع؟",
        delete_failed: "فشل حذف الرسالة",
        employee: "موظف متميز",
        not_connected: "غير متصل حالياً",
        apartment_under_construction: "شقة تحت الإنشاء",
        apartment_ready: "شقة جاهزة",
        roof_under_construction: "روف تحت الإنشاء",
        roof_ready: "روف جاهز",
        villa_under_construction: "فيلا تحت الإنشاء",
        villa_ready: "فيلا جاهزة",
        building: "عمارة",
        land: "أرض",
        rent: "إيجار",
        client_details: "تفاصيل العميل",
        client_details_summary:
            "ملخص بيانات العميل، النطاق الجغرافي، والتفاصيل المالية المستهدفة",
        edit_client: "تعديل العميل",
        basic_client_data: "البيانات الأساسية للعميل",
        client_name: "اسم العميل",
        other_deals: "صفقات أخرى",
        mobile_number: "رقم الجوال",
        client_nationality: "جنسية العميل",
        citizen: "مواطن",
        resident: "مقيم",
        current_client_city: "مدينة العميل الحالية",
        client_request_geographic: "طلب العميل والنطاق الجغرافي المستهدف",
        required_property_type: "نوع العقار المطلوب",
        required_location: "الموقع المطلوب للتملك",
        required_rooms_count: "عدد الغرف المطلوبة",
        financial_funding_data: "البيانات المالية والتمويلية للوحدة",
        client_budget: "ميزانية العميل",
        sar: "ر.س",
        client_salary: "راتب العميل",
        purchase_purpose: "غرض الشراء",
        residential: "سكني",
        investment: "استثماري",
        is_sakani_supported: "هل العميل مدعوم سكني؟",
        support_status: "حالة الدعم",
        supported: "مدعوم",
        not_supported: "غير مدعوم",
        executive_stage_details: "تفاصيل الحالة التنفيذية",
        closing_reason: "سبب الإغلاق",
        enter_statement: "ادخل البيان",
        statement: "البيان",
        official_receipt_note: "ملاحظات الايصال الرسميه",
        company: "الشركة (Internal)",
        receipt: {
            title: "إيصال استلام نقدية",
            date: "التاريخ",
            number: "رقم السند",
            commercial_register: "سجل تجاري",
            tax_number: "الرقم الضريبي",
            company_logo: "شعار الشركة",
            client_name: "اسم العميل",
            unit_number: "رقم الوحدة",
            district: "الحي",
            property_type: "نوع العقار",
            status: "الحالة",
            area: "المساحة",
            square_meter: "م²",
            unit_details: "تفاصيل الوحدة",
            rooms: "غرف",
            bathrooms: "حمام",
            facade: "الواجهة",
            for_statement: "وذلك عن",
            default_statement: "مقابل حجز الوحدة العقارية المذكورة أعلاه.",
            amount_received: "المبلغ المستلم",
            total_amount: "Total Amount",
            currency: "SAR",
            terms_line1:
                "إيصال مالي معتمد إلكترونياً وصادر من النظام المالي للشركة بالبيانات الموضحة أعلاه.",
            terms_line2:
                "تم مراجعة بيانات العقار والمساحات المذكورة ومطابقتها للصكوك الهندسية الرسمية والأنظمة المحلية.",
            authorized_signature: "توقيع وختم الشركة المعتمد",
            official_stamp: "الختم الرسمي",
        },
        no_kitchen_window: "لا يوجد نافذة في المطبخ",
        no_living_room_window: "لا يوجد نافذة في الصالة",
        laborers_in_area: "يوجد عمالة في المنطقة",
        export_image: "تصدير صوره",
        download_image: "تنزيل كصوره",
        exported_successfully: "تم التصدير بنجاح",
        project_visits_stats: "إحصائيات زيارات المشروع",
        select_all_that_apply: "حدد كل الأسباب التي تنطبق",
        analytical_report_title: "تقرير تحليلي للمبيعات والزيارات الميدانية",
        chart_title:
            "📊 التمثيل البياني لتوزيع أسباب الرفض وعدم ملاءمة العقار:",
        visit_unit: "زيارة",
        no_reasons_recorded:
            "لا توجد أسباب فشل مسجلة لعرض مخططها البياني حالياً.",
        image_exported_successfully: "تم تحميل الصورة التحليلية بنجاح",
        error_exporting_image: "فشل تصدير التقرير كصورة",

        comprehensive_global_snapshot: "الملخص المالي الشامل الموحد",
        fixed_accumulated_ledger_snapshot: "الرصيد التراكمي الإجمالي الثابت",
        global_net_profit: "إجمالي صافي الربح الكلي",
        global_credit: "كلي دائن",
        global_debit: "كلي مدين",
        global_receipts: "إجمالي الإيصالات",
        highest_commission: "أعلى عمولة",
        lowest_commission: "أقل عمولة",
        avg_commissions: "متوسط العمولات",
        dynamic_filtered_commissions_analysis:
            "العمولات المفلترة والربحية الحالية",
        filtered_credit: "مفلتر دائن",
        filtered_debit: "مفلتر مدين",
        filtered_net_profit: "صافي الربح المفلتر",
        filtered_max_comm: "أعلى عمولة مفلترة",
        filtered_min_comm: "أقل عمولة مفلترة",
        filtered_avg_comm: "متوسط عمولات مفلتر",
        filtered_approved_receipts_stream: "تدفقات وحركة الإيصالات المفلترة",
        total_filtered_receipts: "إجمالي الإيصالات المفلترة",
        max_receipt: "أعلى إيصال",
        min_receipt: "أقل إيصال",
        avg_receipts_stream: "متوسط الإيصالات",
        receipt_inflow_vs_commission_outflow:
            "مقارنة تدفقات الإيصالات بالعمولات المحققة",
        receipt_impact_desc:
            "وصل الأثر: يوضح كفاءة تحصيل الإيصالات النقدية مقابل الالتزام بالعمولات المستحقة للشركاء.",
        receipts: "الإيصالات",
        credit: "العمولات الدائنة",
        commissions: "العمولات",
        net_profit_saturation_chart: "مخطط تشبع وصافي كفاءة الربح",
        saturation_impact_desc:
            "وصل الأثر: يقيس النسبة المئوية المتبقية كربح حقيقي صافي للشركة من كل ريال يدخل عبر الإيصالات بعد تصفية العمولات المدونة.",
        efficiency: "معدل الكفاءة",
        efficiency_note:
            "كلما زادت النسبة، دل ذلك على قوة الاحتفاظ بالأرباح للشركة.",
        financial_risk_balancing_gap_analysis:
            "مخطط الفجوة وتحليل التوازن المالي للأشهر (Credit vs Debit Gap)",
        gap_impact_desc:
            "وصل الأثر: يساعد الإدارة المالية على مراقبة الفجوة بين الالتزامات الخارجة (المدين) والموارد الداخلة (الدائن) لتفادي أي عجز في السيولة.",
        commissions_distribution_by_classification_type:
            "توزيع العمولات حسب النوع الحالي",
        source: "المصدر",
        debit: "مدين",
        dynamic_employee_financial_performance: "أداء وجدول الموظفين المالي",
        employee_performance_desc:
            "يوضح إنتاجية كل موظف على حدة بناءً على الفلترة النشطة.",
        employee_name: "اسم الموظف",
        total_credit: "إجمالي دائن",
        total_debit: "إجمالي مدين",
        commissions_by_financial_source: "توزيع العمولات حسب المصدر",
        detailed_commissions_deal_by_deal_report:
            "تقرير العمولات المتقدم حسب الصفقات",
        deal_report_desc:
            "حصر شامل لكل صفقة مع بيان الدائن الرئيسي والمستفيدين وحصصهم المالية بالتفصيل.",
        deal_id: "رقم الصفقة",
        primary_creditor: "اسم موظف الدائن",
        micro_beneficiaries_shares: "المستفيدون من العمولات وقيمها",
        na: "غير محدد",
        no_beneficiaries_found: "لا يوجد مستفيدين",
        recent_approved_receipt_requests: "سجل أحدث إيصالات القبض المعتمد",
        sold_date: "تاريخ البيع",
        net_profit: "صافي الربح",
        client_request: "طلب العميل",
        no_additional_details: "لا يوجد تفاصيل اضافية",
        no_notes_available: "لا يوجد ملاحظات متاحه",
        regulations: "المدونة",
        total_assigned_deals: "إجمالي الصفقات المسنده",
        new_deals_count: "مجموع الصفقات الجديده",
        users_performance_desc_histories: "اداء الموظفين حسب السجلات",
        matching_projects: "المشاريع المطابقة",
        smart_matching: "التطابق الذكي",
        yes: "نعم",
        no: "لا",
        closure_reasons: "أسباب الإغلاق",
        request_description: "وصف الطلب",
        under_review: "قيد المراجعة",
        pending_manager: "تحت المراجعة الإدارية",
        pending_finance: "تحت المراجعة المالية",
        approved: "معتمد",
        rejected: "مرفوض",
        rejection_reason: "سبب الرفض",
        commission_status_and_reviews_log: "سجل مراجعات وحالات العمولة",
        no_reason_provided: "لم يتم ذكر سبب.",
        beneficiary: "المستفيد",
        amount: "المبلغ",
        sar: "ر.س",
        approval_stages_and_logs: "مراحل الاعتماد والـ Logs",
        by: "بواسطة",
        automated_system: "النظام التلقائي",
        additional_details: "تفاصيل إضافية",
        close: "إغلاق",
        commissions_distribution: "توزيع العمولات",
        financial_operations: "عمليات ماليّة",
        request_new: "طلب جديد",
        beneficiary: "المستفيد",
        operation_type: "نوع العملية",
        commission_type: "نوع العموية",
        approval_level: "مستوى الموافقة",
        amount: "المبلغ",
        credit_plus: "دائن (+)",
        debit_minus: "مدين (-)",
        sales: "مبيعات",
        solutions: "حلول",
        project: "مشروع",
        disbursement_settlement: "صرف / تسوية",
        sar: "ر.س",
        total_commissions_revenue_credit: "إجمالي إيراد العمولات (الدائن):",
        total_distributions_and_expenses_debit:
            "إجمالي التوزيعات والمصروفات (المدين):",
        net_remaining_commissions_balance: "صافي رصيد العمولات المتبقي:",
        no_commission_data_found: "لم يتم العثور على بيانات عمولات",
        edit_commission: "تعديل العمولة",
        add_commission: "إضافة عمولة",
        transaction_type: "نوع الحساب (العملية المحاسبية)",
        credit_incoming_revenue: "دائن (إيراد مستحق للشركة)",
        debit_deducted_share: "مدين (صرف / حصة مستقطعة)",
        beneficiary: "المستفيد",
        choose_beneficiary: "اختر المستفيد",
        approval_status_level: "حالة مستوى الموافقة",
        commission_type: "نوع العمولة",
        project_commission: "عمولة مشروع",
        sales_commission: "عمولة مبيعات",
        solutions_commission: "عمولة حلول",
        payout_disbursement: "قيد صرف / تسوية مالية",
        date_awarded: "تاريخ الاستحقاق",
        amount_due: "المبلغ المستحق",
        sar: "ر.س",
        additional_details: "تفاصيل إضافية",
        example_external_brokers_share: "مثال: حصة بروكر خارجي",
        cancel: "إلغاء",
        update_data: "تحديث البيانات",
        distribution_adoption: "اعتماد التوزيع",
        error: "خطأ",
        ads_platforms: "منصات الإعلانات",
        manage_ads_platforms: "إدارة منصات الإعلانات",
        platforms_description:
            "إضافة وتعديل منصات النشر التسويقية ومتابعة حالتها الإلزامية.",
        add_new_platform: "إضافة منصة إعلانية جديدة",
        edit_ads_platform: "تعديل منصة إعلانية",
        platform_name: "اسم المنصة",
        platform_placeholder: "مثال: منصة عقار، تيك توك...",
        required_publishing_platform: "منصة إجبارية النشر",
        required_platform_hint:
            "تُلزم الموظف برفع الإعلان عليها (مثل عقار، بيوت)",
        cancel: "إلغاء",
        saving: "جاري الحفظ...",
        update_data: "تحديث البيانات",
        save_platform: "حفظ المنصة",
        registered_platforms_list: "قائمة المنصات المسجلة",
        platform: "منصة",
        table_platform_name: "اسم المنصة",
        table_platform_type: "نوع المنصة",
        table_actions: "العمليات",
        no_platforms_found: "لم يتم العثور على منصات مسجلة حالياً.",
        status_required: "إجبارية",
        status_optional: "اختيارية",
        edit: "تعديل",
        delete: "حذف",
        brokerage_contracts_ads: "إعلانات عقود الوساطة",
        brokerage_ads_title: "عقود الوساطة ومتابعة النشر التسويقي",
        brokerage_ads_subtitle:
            "متابعة تراخيص الإعلانات والروابط المرفوعة على المنصات الإجبارية والاختيارية.",
        search_by_code: "بحث بكود المشروع (رقم الوحدة)",
        search_placeholder: "اكتب رقم الوحدة هنا...",
        ad_platform_status: "حالة النشر بالمنصات",
        all: "الكل",
        completed_required: "مكتمل المنصات الإجبارية",
        never_published: "لم يتم النشر مطلقاً",
        missing_required_platforms: "هناك نقص في المنصات الإجبارية",
        filter_ad_license: "تصفية بالترخيص الإعلاني",
        filter_ad_contract: "تصفية برقم العقد",
        has_license: "يوجد ترخيص إعلاني",
        has_contract: "يوجد رقم العقد",
        no_license: "لا يوجد ترخيص",
        no_contract: "لا يوجد رقم عقد",
        filter_by_employee: "تصفية حسب الموظف",
        all_employees: "كل الموظفين",
        project_unit: "المشروع / الوحدة",
        ad_license_column: "الترخيص الإعلاني",
        required_badge: "إجباري",
        optional_badge: "اختياري",
        actions: "العمليات",
        no_mediation_projects:
            "لم يتم العثور على مشاريع وساطة (Mediation) تطابق الفلاتر.",
        unit_code: "كود",
        no_license_added: "لم يضف ترخيص",
        published: "تم النشر",
        not_published: "غير منشور",
        edit_license_btn: "تعديل الترخيص",
        add_license_btn: "إضافة ترخيص",
        manage_links_btn: "إدارة الروابط",
        manage_links_modal_title: "إدارة روابط المنصات التسويقية",
        cancel: "إلغاء",
        saving: "جاري الحفظ...",
        save_changes: "حفظ التغييرات",
        license_modal_title: "الترخيص الإعلاني للمشروع",
        license_input_label: "أدخل رقم الترخيص الإعلاني المعتمَد",
        license_placeholder: "مثال: 72000xxxx",
        save_license_btn: "حفظ الترخيص",
        brokerage_ads: "عقود الوساطة",
        contract_description_label: "أدخل وصفاً موجزاً لعقد الوساطة (اختياري)",
        sub_contract_description_label:
            "أدخل وصفاً موجزاً للصفقة الفرعية (اختياري)",
        date_sold: "تاريخ البيع",
        beneficiary_totals: "مجموع المستفيدين",
        sort_smallest_area: "أصغر مساحة",
        fixed_accumulated_ledger_snapshot_tip:
            "ملخص تراكمي ثابت يعكس كافة العمليات المالية التاريخية في النظام منذ البداية (غير متأثر بالفلاتر الزمنية الحالية).",
        global_net_profit_tip:
            "صافي الأرباح الإجمالية للشركة: إجمالي المبالغ الدائنة مطروحاً منها كافة الخصومات والمبالغ المدينة التراكمية.",
        global_credit_tip:
            "مجموع كافة العمولات والمبالغ القياسية المستحقة للشركة (الدائنة) منذ التأسيس.",
        global_debit_tip:
            "مجموع كافة العمولات الموزعة على الموظفين أو الخصومات المفروضة (المدينة) منذ التأسيس.",
        global_receipts_tip:
            "مجموع كافة الأموال النقدية التي تم قبضها فعلياً واعتمادها في الخزينة عبر إيصالات القبض.",
        highest_commission_tip:
            "أعلى قيمة عمولة مفردة تم تسجيلها في تاريخ النظام.",
        lowest_commission_tip:
            "أقل قيمة عمولة مفردة تم تسجيلها في تاريخ النظام.",
        avg_commissions_tip:
            "المعدل المتوسط لقيم العمولات المسجلة للعمليات المالية.",
        dynamic_filtered_commissions_analysis_tip:
            "تحليل مالي مرن يتغير فورياً بناءً على تاريخ البحث المحدد أو فلتر الموظف الحالي في أعلى الصفحة.",
        filtered_credit_tip:
            "إجمالي المبالغ الدائنة المسجلة للشركة خلال الفترة الزمنية المحددة للبحث فقط.",
        filtered_debit_tip:
            "إجمالي العمولات والالتزامات الصادرة للموظفين خلال الفترة الزمنية المحددة للبحث فقط.",
        filtered_net_profit_tip:
            "صافي ربح الشركة (الدائن ناقص المدين) المسجل خلال فترة الفلترة المحددة.",
        filtered_max_comm_tip:
            "أعلى عمولة تم تحقيقها ضمن النطاق المفلتر الحالي.",
        filtered_min_comm_tip:
            "أدنى عمولة تم تحقيقها ضمن النطاق المفلتر الحالي.",
        filtered_avg_comm_tip:
            "متوسط العمولات المحتسب للعمليات المنجزة ضمن فترة الفلترة الحالية.",
        filtered_approved_receipts_stream_tip:
            "ملخص تدفقات السيولة النقدية الداخلة للصندوق عبر إيصالات القبض المعتمدة خلال الفترة المحددة.",
        total_filtered_receipts_tip:
            "مجموع المبالغ النقدية المقبوضة فعلياً خلال الفترة الزمنية المحددة للفلترة.",
        max_receipt_tip:
            "أعلى قيمة إيصال قبض مالي منفرد تم اعتماده خلال الفترة الحالية.",
        min_receipt_tip:
            "أقل قيمة إيصال قبض مالي منفرد تم اعتماده خلال الفترة الحالية.",
        avg_receipts_stream_tip:
            "متوسط قيمة المقبوضات النقدية للإيصالات خلال الفترة الحالية.",
        receipt_inflow_vs_commission_outflow_tip:
            "مقارنة بيانية تعرض التوازن بين التدفقات النقدية الداخلة (الإيصالات) مقابل العمولات المستحقة (الدائن) حسب الأشهر.",
        net_profit_saturation_chart_tip:
            "مؤشر يقيس كفاءة الاحتفاظ بالأرباح؛ ونسبة احتفاظ الشركة بصافي الربح بعد تغطية عمولات المستفيدين.",
        financial_risk_balancing_gap_analysis_tip:
            "تحليل بياني يوضح الفجوة وحجم التوازن بين العمولات الدائنة (حقوق الشركة) والعمولات المدينة (حقوق الموظفين والمستفيدين).",
        dynamic_employee_financial_performance_tip:
            "جدول الأداء المالي للموظفين؛ يستعرض إجمالي مستحقات والتزامات كل موظف تم فلترته حسب المدة الزمنية.",
        commissions_distribution_by_classification_type_tip:
            "توزيع مالي يوضح حجم العمولات مصنفة ومجمعة حسب نوع وتصنيف الصفقة العقارية/الإدارية.",
        detailed_commissions_deal_by_deal_report_tip:
            "تقرير تفصيلي متطور يعرض الحالات المالية لكل صفقة أو عقد بشكل مستقل مع تفصيل المستفيدين منها.",
        contract_number_tip:
            "رقم العقد الفريد المرتبط بالصفقة؛ انقر عليه لنسخه مباشرة إلى الحافظة.",
        status_tip:
            "الحالة المالية العامة للصفقة بناءً على مراجعة واعتماد العمولات التابعة لها.",
        primary_creditor_tip:
            "الموظف أو الوسيط الأساسي المسؤول عن إتمام العقد وجلب الصفقة.",
        total_credit_tip:
            "القيمة الإجمالية التقديرية لعمولة الصفقة الدائنة المخصصة للحساب الأساسي للشركة.",
        total_debit_tip:
            "مجموع العمولات المستقطعة من هذه الصفقة والمستحقة للموظفين والشركاء الآخرين.",
        net_profit_tip:
            "صافي ربح الشركة من هذه الصفقة بالذات بعد استقطاع كافة عمولات المستفيدين.",
        beneficiary_totals_tip:
            "المجموع الكلي النهائي الموحد لما يستحقه كل موظف مدين في هذه الصفقة بالذات بغض النظر عن تفرع وتعدد حالات عمولاته.",
        micro_beneficiaries_shares_tip:
            "الحالة التفصيلية الدقيقة لكل عمولة فرعية مستقطعة (معتمد ✅، قيد الانتظار ⏳، مرفوض ❌).",
        recent_approved_receipt_requests_tip:
            "سجل يعرض آخر عمليات القبض النقدية التي تمت الموافقة عليها ودخلت صندوق المؤسسة مؤخراً.",
        stage_transitions_tip:
            "إجمالي عمليات نقل وتغيير مراحل الصفقات العقارية من مرحلة إلى أخرى داخل النظام خلال الفترة المحددة.",
        executed_activities_tip:
            "عدد المهام والأنشطة الإجمالية الفردية التي قام بها فريق العمل (مثل المكالمات، الزيارات، المعاينات).",
        new_projects_added_tip:
            "عدد المشاريع والمجمعات العقارية الجديدة التي تم إدخالها وتكويدها في قاعدة البيانات مؤخراً.",
        new_clients_tip:
            "العملاء الجدد الذين تم تسجيل بياناتهم في النظام وبدء التواصل معهم خلال الفترة الحالية.",
        new_developers_tip:
            "عدد المطورين العقاريين أو الشركات العقارية الجديدة التي تم توقيع شراكات معها وإضافتها للنظام.",
        activity_density_analysis_tip:
            "مخطط بياني يوضح حجم وكثافة الأنشطة المنفذة من قِبل الفريق، موزعة زمنياً لمراقبة ذروة العمل.",
        final_closing_rate_tip:
            "نسبة النجاح الإجمالية؛ تمثل النسبة المئوية للمشاريع أو العملاء المحتملين الذين تحولوا إلى صفقات مباعة بنجاح.",
        sold_deals_count_tip:
            "العدد الإجمالي للعقود والوحدات العقارية التي تم إغلاقها وتوقيع عقود بيعها بشكل نهائي.",
        active_deals_tip:
            "الاعتمادات أو الصفقات الحالية التي لا تزال تحت الإجراء أو المراجعة ولم يتم إغلاقها أو رفضها بعد.",
        top_3_sales_sources_tip:
            "أعلى 3 قنوات تسويقية أو مصادر جلب للعملاء حققت أعلى معدل لإتمام الصفقات والمبيعات للشركة.",
        market_gap: {
            title: "تحليل الفجوة السوقية (مقارنة الطلب بالعرض - فجوات العجز فقط)",
            subtitle:
                "يستعرض هذا التحليل صفقات العجز الحالي الفعلي في السوق مع استبعاد الطلبات المغطاة.",
            deficit_badge: "عجز (طلب بدون عرض كافٍ)",
            empty_state:
                "لا توجد أي فجوات عجز في الطلبات الحالية. كل الطلبات مغطاة بالكامل!",
            table: {
                region_district: "المنطقة والحي",
                target_request_type: "نوع الطلب المستهدف",
                rooms: "الغرف",
                demands: "الطلبات (الطلب)",
                available: "المتاح (العرض)",
                gap_status: "حالة ومستوى الفجوة",
                price_average: "معدل الأسعار (ميزانية العميل vs السوق)",
                click_to_copy: "انقر على رقم العقد لنسخه",
                deficit_count: "عجز {count} وحدة",
                client_budget: "ميزانية العميل:",
                market_supply: "متاح السوق:",
                no_inventory_price: "لا يوجد مخزون للتسعير",
            },
        },
        download_all_images: "تنزيل جميع الصور",
        need_payment: "يحتاج سداد",
        new_clients: "عملاء جدد",
        current_live_snapshot: "الوضع اللحظي الشامل للعملاء",
        live_snapshot_desc:
            "إحصائيات شاملة ومباشرة لكافة العملاء بالنظام (غير متأثرة بفلاتر البحث)",
        total_clients_now: "إجمالي العملاء بالنظام",
        main_stages_now: "توزيع المراحل الأساسية الشاملة",
        bank_sub_stages_now: "الحالات الفرعية للبنك الشاملة",

        filtered_live_snapshot: "الوضع اللحظي الخاص (المستخدم / الدور)",
        filtered_snapshot_desc:
            "إحصائيات مباشرة مصفاة بحسب اختيارك للمستخدم أو الدور (غير متأثرة بفلتر التاريخ)",
        filtered_clients_now: "العملاء للمحدد حالياً",
        main_stages_filtered_now: "توزيع المراحل الأساسية للمحدد",
        bank_sub_stages_filtered_now: "الحالات الفرعية للبنك للمحدد",

        users_performance_summary: "ملخص أداء الموظفين",
        users_performance_desc_histories:
            "عرض تفصيل الصفقات تحت الإدارة وعدد الصفقات الجديدة المحتسبة تاريخياً بناءً على سجلات الصفقات",
        employee_name: "اسم الموظف",
        employee_role: "الدور الوظيفي",
        total_assigned_deals: "إجمالي الصفقات تحت الإدارة",
        new_deals_count: "عدد الصفقات الجديدة (New)",
        no_users_found: "لا يوجد مستخدمين مسجلين حالياً",

        commissions_earned_completed_sales:
            "العمولات المكتسبة (المبيعات المكتملة)",
        expected_commissions_pipeline: "العمولات المتوقعة (تحت الإجراء)",
        sar: "ريال",
        activity_efficiency: "كفاءة الأنشطة والأداء",
        visit_success_rate: "نسبة نجاح الزيارات",
        call_success_rate: "نسبة نجاح المكالمات",

        pipeline_stages: "مراحل التدفق (Pipeline)",
        conversion_efficiency: "كفاءة التحويل ونسب النجاح",
        sequential_conversion: "التحويل المتتالي بين المراحل",
        direct_target_conversion: "التحويل المباشر للهدف النهائى",

        marketing_channel_analysis: "تحليل القنوات التسويقية",
        marketing_channel_analysis_description:
            "أداء مصادر الصفقات ونسب التحويل إلى مبيعات ناجحة",
        incoming_deal: "صفقة واردة",
        sold_deals: "صفقة مباعة",
        success_rate: "نسبة النجاح",

        payment_methods: "طرق الدفع المفضلة للعملاء",
        cash: "كاش",
        bank_finance: "تمويل بنكي",
        bank_stages_analysis: "تحليل صفقات البنوك حسب المرحلة",
        deals: "صفقة",

        lead_quality_and_demographics: "جودة العملاء والتركيبة الديموغرافية",
        avg_seriousness_score: "متوسط تقييم جدية العملاء",
        sakani_supported: "دعم سكني",
        supported: "مدعوم",
        not_supported: "غير مدعوم",
        residential_vs_investment: "الغرض من الشراء (سكني / استثماري)",
        nationality_ratio: "نسبة الجنسيات (مواطن / مقيم)",
        deals_by_city: "توزيع الصفقات حسب المدن",
        client_count_unit: "عميل",

        active_banks_analysis: "تحليل البنوك النشطة بالنظام",
        top_bank_employees: "أعلى موظفي البنوك تفاعلاً",
        deal_loss_reasons: "أسباب خسارة وإغلاق الصفقات",

        // نصوص تلميحات الأدوات (Tooltips)
        tooltip_total_clients:
            "يمثل العدد الكلي والفعلي لجميع العملاء المسجلين في قاعدة البيانات بدون أي فلاتر.",
        tooltip_filtered_clients:
            "عدد العملاء المخصصين للموظف أو الدور الذي قمت بتحديده في الفلتر العلوي حالياً.",
        tooltip_earned_commissions:
            "إجمالي المبالغ والعمولات المستحقة التي تم إغلاق صفقاتها بنجاح كمبيعات مكتملة.",
        tooltip_pipeline_commissions:
            "العمولات التقديرية المتوقعة من الصفقات الجارية والتي ما زالت تحت الإجراء بالمراحل المختلفة.",
        tooltip_activity_efficiency:
            "مؤشر يعكس مدى فعالية الزيارات الميدانية والاتصالات الهاتفية في دفع الصفقات للأمام.",
        tooltip_avg_seriousness:
            "معدل تقييم الجدية التقريبي لطلبات العملاء من 5 درجات.",
        tooltip_sakani_support:
            "توزيع العملاء المؤهلين للحصول على دعم برنامج سكني مقارنة بالغير مدعومين.",
        tooltip_purpose:
            "نسبة طلبات العقارات السكنية الخاصة مقارنة بالعقارات الاستثمارية.",
        tooltip_nationality:
            "التوزيع النسبي لأعداد العملاء المواطنين مقابل المقيمين بالنظام.",
        cash_deals_desc:
            "النسبة المئوية والعدد الإجمالي للعملاء الذين يفضلون الشراء النقدي (كاش).",
        bank_finance_deals_desc:
            "النسبة المئوية والعدد الإجمالي للعملاء الذين يتطلب إتمام صفقاتهم تمويلاً بنكياً.",
        current_live_snapshot_tip:
            "تعرض هذه اللقطة إجمالي عدد العملاء المسجلين حالياً في النظام وتوزيعهم الفوري على كافة المراحل الأساسية ومراحل البنوك الفرعية دون أي فلاتر زمنية.",
        filtered_live_snapshot_tip:
            "تعرض هذه اللقطة البيانات الفورية للعملاء بناءً على معايير التصفية والفلترة النشطة التي قمت بتحديدها (مثل الفلترة بالتاريخ أو الموظف).",
        users_performance_summary_tip:
            "ملخص يوضح حجم الصفقات الإجمالي الموزع على كل موظف، مع إبراز عدد الصفقات الجديدة المضافة مؤخراً لتقييم النشاط الحالي.",
        pipeline_stages_tip:
            "مخطط يوضح حركة تدفق الصفقات وتوزيعها العددي عبر المراحل التسويقية والبيعية الرئيسية للمنشأة.",
        marketing_channel_analysis_tip:
            "تحليل أداء القنوات الإعلانية من خلال تتبع عدد الصفقات الواردة ونسبة نجاح كل قناة في إتمام الصفقات (البيع).",
        bank_stages_analysis_tip:
            "مخطط يوضح توزيع المعاملات العقارية الحالية داخل أروقة ومراحل التقييم والاعتماد لدى البنوك والجهات التمويلية.",
        lead_quality_and_demographics_tip:
            "مؤشرات ديموغرافية تقيس متوسط جدية العملاء، ونسبة الدعم السكني، والغرض من الشراء (سكني/استثماري) بالإضافة إلى الجنسية.",
        sub_contract_description: "وصف الصفقة الفرعية",
        brokerage_contracts_ads: "إعلانات عقود الوساطة",
        brokerage_ads_title: "منصات إعلانات عقود الوساطة والتسويق",
        brokerage_ads_subtitle:
            "متابعة وإدارة نشر الوحدات العقارية عبر المنصات الإعلانية الإلزامية والاختيارية وتوثيق التراخيص.",
        loading: "جاري التحميل...",
        refresh: "تحديث البيانات",
        all: "الكل",
        completed_required: "مكتمل المنصات الإلزامية",
        never_published: "لم ينشر أبداً",
        missing_required_platforms: "ناقص منصات إلزامية",
        has_contract: "يوجد عقد / ترخيص",
        no_contract: "لا يوجد عقد",
        all_employees: "كل الموظفين",
        project_unit: "المشروع / الوحدة",
        ad_license_column: "رقم الترخيص الإعلاني",
        ad_contract_column: "رقم العقد",
        required_badge: "إلزامي",
        optional_badge: "اختياري",
        actions: "العمليات",
        no_mediation_projects: "لا توجد مشاريع وساطة تطابق الفلاتر المحددة.",
        copy_to_clipboard: "اضغط لنسخ رقم الوحدة",
        no_license_added: "لم يتم إضافة ترخيص",
        contract_badge: "العقد",
        sub_contract_badge: "الفرعي",
        main_contract_description_title: "وصف العقد الرئيسي",
        sub_contract_description_title: "وصف العقد الفرعي",
        published: "منشور",
        not_published: "غير منشور",
        edit_data: "تعديل البيانات",
        add_contract_data: "إضافة بيانات العقد",
        manage_links_btn: "إدارة الروابط",
        manage_links_modal_title: "إدارة روابط المنصات الإعلانية",
        cancel: "إلغاء",
        saving: "جاري الحفظ...",
        save_changes: "حفظ التغييرات",
        edit_contract_license_modal_title: "تعديل بيانات العقد والترخيص لـ",
        license_input_label: "رقم الترخيص الإعلاني (الهيئة العامة للعقار)",
        search_by_code: "بحث برقم الوحدة / العقد",
        search_placeholder: "ابحث برقم الوحدة أو الكود...",
        contract_description_filter: "تفاصيل العقود",
        contract_description_placeholder: "ابحث بتفاصيل العقد...",
        sub_contract_description_filter: "تفاصيل العقود الفرعية",
        sub_contract_description_placeholder: "ابحث بالعقود الفرعية...",
        ad_platform_status: "حالة الإعلان بالمنصات",
        filter_ad_contract: "فلتر وجود عقد إعلاني",
        filter_by_employee: "تصفية حسب الموظف",

        // فلاتر الحالات الديناميكية (Sale Status)
        sale_status_all: "كل الحالات",
        sale_status_available: "متاح",
        sale_status_sold: "مباع",
        sale_status_reserved: "محجوز",
        sale_status_not_available: "غير متاح",

        // فلاتر أنواع العقود (Contract Types)
        contract_type_all: "كل العقود",
        contract_type_exclusive: "حصري",
        contract_type_mediation: "وساطة",
        requested_by: "مقدم الطلب",
        approval_levels: "مستويات الموافقه",
        detailed_receipts_report: "تقرير الإيصالات التفصيلي",
        detailed_receipts_report_tip:
            "يعرض هذا التقرير سجل الحركات المالية التفصيلية لطلبات الإيصالات (الدائنة والمدينة) التي تمت على الصفقات خلال الفترة المحددة مع إمكانية تتبع حالة كل إيصال والمحرر المسؤول عنه.",
        receipts_report_desc:
            "متابعة وتدقيق حركات الإيصالات الصادرة والواردة وحالات الاعتماد الخاصة بها.",
        receipt_number: "رقم الإيصال / العميل",
        receipt_number_tip:
            "اضغط على رقم الإيصال لفتح تفاصيل الصفقة المرتبطة به مباشرة.",
        action_type: "نوع الحركة",
        amount: "المبلغ",
        status: "الحالة",
        receipt_status_tip:
            "توضح حالة الاعتماد الحالية للإيصال في الدورة المستندية (مقبول، قيد المراجعة، أو معلق).",
        receipt_date: "التاريخ",
        primary_issuer: "محرر الإيصال",
        primary_issuer_tip:
            "الموظف أو المستخدم الذي قام بإنشاء ورفع طلب الإيصال على النظام.",
        details: "التفاصيل / البيان",
        approved: "معتمد",
        under_review: "قيد المراجعة",
        pending_manager: "انتظار المدير",
        pending_finance: "انتظار المالية",
        rejected: "مرفوض",
        unknown: "غير معروف",
        na: "غير متوفر",
        external_show: "عقار خارجي",
        external_property: "عقار خارجي",
        projects_sales_commission: "عمولة المبيعات والمشروع",
        mark_as_external_property_desc:
            "تحديد ما إذا كان هذا العقار من خارج المشاريع الموجودة في النظام",
        project_commission_status: "حالة عمولة المشروع",
        project_commission_debit: "المستقطع من عمولة المشروع (مدين)",
        project_commission_credit: "إجمالي عمولة المشروع (دائن)",

        sales_commission_status: "حالة عمولة المبيعات",
        sales_commission_debit: "المستقطع من عمولة المبيعات (مدين)",
        sales_commission_credit: "إجمالي عمولة المبيعات (دائن)",

        solutions_commission_status: "حالة عمولة الحلول",
        solutions_commission_debit: "المستقطع من عمولة الحلول (مدين)",
        solutions_commission_credit: "إجمالي عمولة الحلول (دائن)",

        grand_total: "الإجمالي العام",
        view_receipt: "عرض الايصال",
        receipts_total_debit: "إجمالي الإيصالات المدينة",
        receipts_total_credit: "إجمالي الإيصالات الدائنة",
    },
};

export default messages;
